import React, { useState, useEffect, useMemo } from 'react';
import { Box, Card, CardContent, Typography, ToggleButton, ToggleButtonGroup, TextField, Grid, Stack, Button, CircularProgress } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format, parseISO, getDay, subDays } from 'date-fns';
import { tr } from 'date-fns/locale';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Icon } from '@iconify/react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import downloadIcon from '../assets/images/download-icon.svg';
import Services from '../services/Services';
import api from 'src/services/BaseService';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const channelFilters = ['Toplam', 'AVM', 'EPX', 'Esnaf', 'Bireysel', 'Kurumsal'];
//  "shopify", "dhl" aşağı eklenecek
const firmaList = ["trendyol", "aras-kargo", "hepsijet", "hepsiburada", "kargoist"];
const firmaColors = {
    "trendyol": "#F2994A",
    "aras-kargo": "#EB5757",
    "hepsijet": "#56CCF2",
    "hepsiburada": "#27AE60",
    "kargoist": "#9B51E0",
    "shopify": "#2F80ED",
    "dhl": "#F2C94C"
};
const dayNames = ['Pazar', 'P.tesi', 'Salı', 'Çarş', 'Perş', 'Cuma', 'C.tesi'];

// Her gönderinin bir channel'ı ve bir firma'sı var
const mockShipments = [
    { id: 1, date: '2025-04-04', channel: 'AVM', firma: 'HB', shipmentType: 'Paket', price: 1500, deliveryType: 'Esnaf' },
    { id: 2, date: '2025-04-04', channel: 'AVM', firma: 'Trendyol', shipmentType: 'Döküman', price: 1800, deliveryType: 'AVM' },
    { id: 3, date: '2025-04-04', channel: 'Kurumsal', firma: 'Aras', shipmentType: 'Paket', price: 900, deliveryType: 'Esnaf' },
    { id: 4, date: '2025-04-04', channel: 'Kurumsal', firma: 'N11', shipmentType: 'Paket', price: 700, deliveryType: 'AVM' },
    { id: 5, date: '2025-04-03', channel: 'Bireysel', firma: 'HB', shipmentType: 'Döküman', price: 1400, deliveryType: 'AVM' },
    { id: 6, date: '2025-04-03', channel: 'Bireysel', firma: 'Trendyol', shipmentType: 'Paket', price: 1900, deliveryType: 'Esnaf' },
    { id: 7, date: '2025-04-03', channel: 'EPX', firma: 'Aras', shipmentType: 'Paket', price: 950, deliveryType: 'AVM' },
    { id: 8, date: '2025-04-03', channel: 'EPX', firma: 'N11', shipmentType: 'Döküman', price: 800, deliveryType: 'Esnaf' },
    { id: 9, date: '2025-04-02', channel: 'AVM', firma: 'DHL', shipmentType: 'Paket', price: 1600, deliveryType: 'Esnaf' },
    { id: 10, date: '2025-04-02', channel: 'Kurumsal', firma: 'MNG', shipmentType: 'Döküman', price: 1700, deliveryType: 'AVM' },
    { id: 11, date: '2025-04-02', channel: 'Bireysel', firma: 'Yurtiçi', shipmentType: 'Paket', price: 1200, deliveryType: 'Esnaf' },
    { id: 12, date: '2025-04-02', channel: 'EPX', firma: 'UPS', shipmentType: 'Paket', price: 1100, deliveryType: 'AVM' },
    { id: 13, date: '2025-04-01', channel: 'AVM', firma: 'HB', shipmentType: 'Paket', price: 1550, deliveryType: 'Esnaf' },
    { id: 14, date: '2025-04-01', channel: 'Kurumsal', firma: 'Trendyol', shipmentType: 'Döküman', price: 1850, deliveryType: 'AVM' },
    { id: 15, date: '2025-04-01', channel: 'Bireysel', firma: 'Aras', shipmentType: 'Paket', price: 920, deliveryType: 'Esnaf' },
    { id: 16, date: '2025-04-01', channel: 'EPX', firma: 'N11', shipmentType: 'Paket', price: 750, deliveryType: 'AVM' },
    { id: 17, date: '2025-03-31', channel: 'AVM', firma: 'DHL', shipmentType: 'Paket', price: 1620, deliveryType: 'Esnaf' },
    { id: 18, date: '2025-03-31', channel: 'Kurumsal', firma: 'MNG', shipmentType: 'Döküman', price: 1720, deliveryType: 'AVM' },
    { id: 19, date: '2025-03-31', channel: 'Bireysel', firma: 'Yurtiçi', shipmentType: 'Paket', price: 1250, deliveryType: 'Esnaf' },
    { id: 20, date: '2025-03-31', channel: 'EPX', firma: 'UPS', shipmentType: 'Paket', price: 1150, deliveryType: 'AVM' },
    // Ekstra veriler
    { id: 21, date: '2025-04-05', channel: 'AVM', firma: 'HB', shipmentType: 'Paket', price: 1700, deliveryType: 'Esnaf' },
    { id: 22, date: '2025-04-05', channel: 'Kurumsal', firma: 'Trendyol', shipmentType: 'Döküman', price: 2100, deliveryType: 'AVM' },
    { id: 23, date: '2025-04-05', channel: 'Bireysel', firma: 'Aras', shipmentType: 'Paket', price: 950, deliveryType: 'Esnaf' },
    { id: 24, date: '2025-04-05', channel: 'EPX', firma: 'N11', shipmentType: 'Paket', price: 800, deliveryType: 'AVM' },
    { id: 25, date: '2025-04-06', channel: 'AVM', firma: 'DHL', shipmentType: 'Paket', price: 1800, deliveryType: 'Esnaf' },
    { id: 26, date: '2025-04-06', channel: 'Kurumsal', firma: 'MNG', shipmentType: 'Döküman', price: 2000, deliveryType: 'AVM' },
    { id: 27, date: '2025-04-06', channel: 'Bireysel', firma: 'Yurtiçi', shipmentType: 'Paket', price: 1300, deliveryType: 'Esnaf' },
    { id: 28, date: '2025-04-06', channel: 'EPX', firma: 'UPS', shipmentType: 'Paket', price: 1200, deliveryType: 'AVM' },
    { id: 29, date: '2025-04-07', channel: 'AVM', firma: 'HB', shipmentType: 'Paket', price: 1750, deliveryType: 'Esnaf' },
    { id: 30, date: '2025-04-07', channel: 'Kurumsal', firma: 'Trendyol', shipmentType: 'Döküman', price: 2150, deliveryType: 'AVM' },
    { id: 31, date: '2025-04-07', channel: 'Bireysel', firma: 'Aras', shipmentType: 'Paket', price: 970, deliveryType: 'Esnaf' },
    { id: 32, date: '2025-04-07', channel: 'EPX', firma: 'N11', shipmentType: 'Paket', price: 820, deliveryType: 'AVM' },
    { id: 33, date: '2025-04-08', channel: 'AVM', firma: 'DHL', shipmentType: 'Paket', price: 1850, deliveryType: 'Esnaf' },
    { id: 34, date: '2025-04-08', channel: 'Kurumsal', firma: 'MNG', shipmentType: 'Döküman', price: 2050, deliveryType: 'AVM' },
    { id: 35, date: '2025-04-08', channel: 'Bireysel', firma: 'Yurtiçi', shipmentType: 'Paket', price: 1350, deliveryType: 'Esnaf' },
    { id: 36, date: '2025-04-08', channel: 'EPX', firma: 'UPS', shipmentType: 'Paket', price: 1250, deliveryType: 'AVM' },
];

function getDayName(dateStr) {
    const dayIdx = getDay(parseISO(dateStr));
    return dayNames[dayIdx];
}

// Tablo için yardımcı fonksiyonlar
function countByDay(firma, date) {
    return mockShipments.filter(s => s.firma === firma && s.date === date).length;
}
function countByWeek(firma, refDate) {
    const ref = new Date(refDate);
    const weekAgo = new Date(ref);
    weekAgo.setDate(ref.getDate() - 6);
    return mockShipments.filter(s => s.firma === firma && new Date(s.date) <= ref && new Date(s.date) >= weekAgo).length;
}
function countByMonth(firma, refDate) {
    const ref = new Date(refDate);
    const monthAgo = new Date(ref);
    monthAgo.setDate(ref.getDate() - 29);
    return mockShipments.filter(s => s.firma === firma && new Date(s.date) <= ref && new Date(s.date) >= monthAgo).length;
}
function percentChange(current, prev) {
    if (prev === 0) return current === 0 ? 0 : 100;
    return Math.round(((current - prev) / prev) * 100);
}

// Tablo datası hazırla
const tableFirms = firmaList;
const allDates = Array.from(new Set(mockShipments.map(s => s.date))).sort((a, b) => new Date(b) - new Date(a));
const today = allDates[0];
const prevDay = allDates[1] || allDates[0];
const lastWeek = allDates[6] || allDates[allDates.length - 1];
const lastMonth = allDates[20] || allDates[allDates.length - 1];
const tableRows = tableFirms.map(firma => {
    const todayCount = countByDay(firma, today);
    const prevDayCount = countByDay(firma, prevDay);
    const weekCount = countByWeek(firma, today);
    const lastWeekCount = countByWeek(firma, lastWeek);
    const monthCount = countByMonth(firma, today);
    const lastMonthCount = countByMonth(firma, lastMonth);
    return {
        firma,
        today: todayCount,
        prevDay: prevDayCount,
        DoD: percentChange(todayCount, prevDayCount),
        week: weekCount,
        lastWeek: lastWeekCount,
        Wow: percentChange(weekCount, lastWeekCount),
        month: monthCount,
        lastMonth: lastMonthCount,
        MoM: percentChange(monthCount, lastMonthCount),
    };
});
// Yardımcı fonksiyon: tarih aralığını güzel göster
function getDateRangeLabel(start, end) {
    if (!start && !end) return '';
    if (start && end) {
        return `${format(start, 'dd.MM.yyyy')} - ${format(end, 'dd.MM.yyyy')}`;
    }
    if (start) return `${format(start, 'dd.MM.yyyy')} sonrası`;
    if (end) return `${format(end, 'dd.MM.yyyy')} öncesi`;
    return '';
}

// Yardımcı fonksiyon: ay adını Türkçe döndür
function getMonthNameTR(date) {
    const aylar = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    return aylar[date.getMonth()];
}

function getChangeColor(val) {
    if (val > 0) return '#43A047';   // Yeşil
    if (val < 0) return '#E95050';   // Kırmızı
    return '#888888';                // Gri
}

{/* Excel Export Fonksiyonları */ }

// Export functions for each table


const exportIslemAdetleriPDF = (statsData, dateRangeLabel, startDate, endDate, prevMonthStats = null) => {
    const tableFirms = firmaList;
    const todayDate = endDate ? new Date(endDate) : new Date();
    const todayStr = format(todayDate, 'yyyy-MM-dd');
    const prevDayDate = new Date(todayDate); prevDayDate.setDate(todayDate.getDate() - 1);
    const prevDayStr = format(prevDayDate, 'yyyy-MM-dd');
    const beforePrevDayDate = new Date(todayDate); beforePrevDayDate.setDate(todayDate.getDate() - 2);
    const beforePrevDayStr = format(beforePrevDayDate, 'yyyy-MM-dd');
    const weekAgoDate = new Date(todayDate); weekAgoDate.setDate(todayDate.getDate() - 6);
    // Geçen hafta başlangıç tarihi (weekAgoDate'den 7 gün önce)
    const startOfLastWeek = new Date(weekAgoDate);
    startOfLastWeek.setDate(weekAgoDate.getDate() - 7);
    const monthAgoDate = new Date(todayDate); monthAgoDate.setDate(todayDate.getDate() - 29);
    // Geçen ay başlangıç tarihi (monthAgoDate'den 30 gün önce)
    const startOfLastMonth = new Date(monthAgoDate);
    startOfLastMonth.setDate(monthAgoDate.getDate() - 30);

    // Tablonun kullandığı mantıkla tutarlı hale getirildi
    function countByDay(firma, dateStr, data) {
        const channelData = data?.[firma];
        if (!channelData || !channelData.dates) return 0;
        return channelData.dates[dateStr] || 0;
    }

    // Tablonun kullandığı mantıkla tutarlı hale getirildi
    function countByRange(firma, start, end, data) {
        const channelData = data?.[firma];
        if (!channelData || !channelData.dates) return 0;
        let total = 0;
        const startStr = format(start, 'yyyy-MM-dd');
        const endStr = format(end, 'yyyy-MM-dd');
        Object.entries(channelData.dates).forEach(([date, count]) => {
            // Tarih stringlerini karşılaştır
            if (date >= startStr && date <= endStr) {
                total += count;
            }
        });
        return total;
    }

    // Tablonun kullandığı mantıkla tutarlı hale getirildi
    function percentChange(current, prev) {
        if (prev === 0) return current === 0 ? 0 : Math.round((current / 1) * 100); // Payda 0 ise, pay > 0 ise %100 artış, pay = 0 ise %0 değişim
        return Math.round(((current - prev) / prev) * 100);
    }

    const tableRows = tableFirms.map(firma => {
        // Ana statsData'yı kullanarak gün bazlı hesaplamalar
        const todayCount = countByDay(firma, todayStr, statsData);
        const prevDayCount = countByDay(firma, prevDayStr, statsData);
        const beforePrevDayCount = countByDay(firma, beforePrevDayStr, statsData);
        const weekCount = countByRange(firma, weekAgoDate, todayDate, statsData);
        // Geçen hafta için bir önceki 7 günün toplamı (MoM mantığı gibi)
        const lastWeekCount = countByRange(firma, startOfLastWeek, weekAgoDate, statsData);
        const monthCount = countByRange(firma, monthAgoDate, todayDate, statsData);

        // MoM sadece total ile hesaplanacak (prevMonthStats kullanılıyor)
        let lastMonthTotal = 0;
        if (prevMonthStats && prevMonthStats[firma] && prevMonthStats[firma].total) {
            lastMonthTotal = prevMonthStats[firma].total;
        }
        let thisMonthTotal = 0;
        if (statsData && statsData[firma] && statsData[firma].total) {
            thisMonthTotal = statsData[firma].total;
        }
        const MoM = percentChange(thisMonthTotal, lastMonthTotal);

        return {
            firma,
            today: todayCount, // statsData'dan
            prevDay: prevDayCount, // statsData'dan
            beforePrevDay: beforePrevDayCount, // statsData'dan
            DoD: percentChange(todayCount, prevDayCount),
            week: weekCount, // statsData'dan
            lastWeek: lastWeekCount, // statsData'dan (bir önceki hafta)
            Wow: percentChange(weekCount, lastWeekCount),
            month: monthCount, // statsData'dan (son 30 gün)
            lastMonth: lastMonthTotal, // prevMonthStats'tan
            MoM: MoM, // statsData ve prevMonthStats'tan
        };
    });

    const totalRow = { // Total satırı da aynı hesaplama mantığını kullanacak
        firma: 'E-Ticaret Toplam',
        today: tableRows.reduce((a, b) => a + b.today, 0),
        prevDay: tableRows.reduce((a, b) => a + b.prevDay, 0),
        beforePrevDay: tableRows.reduce((a, b) => a + b.beforePrevDay, 0),
        DoD: percentChange(
            tableRows.reduce((a, b) => a + b.today, 0),
            tableRows.reduce((a, b) => a + b.prevDay, 0)
        ),
        week: tableRows.reduce((a, b) => a + b.week, 0),
        lastWeek: tableRows.reduce((a, b) => a + b.lastWeek, 0),
        Wow: percentChange(
            tableRows.reduce((a, b) => a + b.week, 0),
            tableRows.reduce((a, b) => a + b.lastWeek, 0)
        ),
        month: tableRows.reduce((a, b) => a + b.month, 0),
        lastMonth: tableRows.reduce((a, b) => a + b.lastMonth, 0),
        MoM: percentChange(
            tableRows.reduce((a, b) => a + b.month, 0),
            tableRows.reduce((a, b) => a + b.lastMonth, 0)
        ),
    };

    const tableBody = [
        [ // Başlık satırı
            { text: 'Marka', bold: true },
            { text: format(todayDate, 'dd.MM.yyyy'), bold: true },
            { text: format(prevDayDate, 'dd.MM.yyyy'), bold: true },
            { text: format(beforePrevDayDate, 'dd.MM.yyyy'), bold: true },
            { text: 'DoD', bold: true },
            { text: format(weekAgoDate, 'dd.MM.yyyy'), bold: true },
            { text: 'Wow', bold: true },
            { text: format(monthAgoDate, 'dd.MM.yyyy'), bold: true },
            { text: 'MoM', bold: true }
        ],
        // Veri satırları
        ...tableRows.map(row => [
            row.firma,
            row.today,
            row.prevDay,
            row.beforePrevDay,
            { text: `${row.DoD}%`, color: getChangeColor(row.DoD) },
            row.week,
            { text: `${row.Wow}%`, color: getChangeColor(row.Wow) },
            row.month,
            { text: `${row.MoM}%`, color: getChangeColor(row.MoM) }
        ]),
        [ // Toplam satırı
            { text: totalRow.firma, bold: true },
            { text: totalRow.today, bold: true },
            { text: totalRow.prevDay, bold: true },
            { text: totalRow.beforePrevDay, bold: true },
            { text: `${totalRow.DoD}%`, bold: true, color: getChangeColor(totalRow.DoD) },
            { text: totalRow.week, bold: true },
            { text: `${totalRow.Wow}%`, bold: true, color: getChangeColor(totalRow.Wow) },
            { text: totalRow.month, bold: true },
            { text: `${totalRow.MoM}%`, bold: true, color: getChangeColor(totalRow.MoM) } // MoM değeri prevMonthStats kullanılarak hesaplandı
        ]
    ];

    const docDefinition = {
        content: [
            { text: `İşlem Adetleri ${dateRangeLabel}`, style: 'header' },
            {
                table: {
                    headerRows: 1,
                    widths: [
                        "*",
                        "auto", "auto", "auto", "auto", "auto", "auto", "auto", "auto"
                    ],
                    body: tableBody
                }
            }
        ],
        styles: {
            header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] }
        }
    };
    pdfMake.createPdf(docDefinition).download(`islem_adetleri_${dateRangeLabel}.pdf`);
};

const exportIslemAdetleriExcel = (statsData, dateRangeLabel, startDate, endDate, prevMonthStats = null) => {
    const tableFirms = firmaList;
    const todayDate = endDate ? new Date(endDate) : new Date();
    const todayStr = format(todayDate, 'yyyy-MM-dd');
    const prevDayDate = new Date(todayDate); prevDayDate.setDate(todayDate.getDate() - 1);
    const prevDayStr = format(prevDayDate, 'yyyy-MM-dd');
    const beforePrevDayDate = new Date(todayDate); beforePrevDayDate.setDate(todayDate.getDate() - 2);
    const beforePrevDayStr = format(beforePrevDayDate, 'yyyy-MM-dd');
    const weekAgoDate = new Date(todayDate); weekAgoDate.setDate(todayDate.getDate() - 6);
     // Geçen hafta başlangıç tarihi (weekAgoDate'den 7 gün önce)
    const startOfLastWeek = new Date(weekAgoDate);
    startOfLastWeek.setDate(weekAgoDate.getDate() - 7);
    const monthAgoDate = new Date(todayDate); monthAgoDate.setDate(todayDate.getDate() - 29);
    // Geçen ay başlangıç tarihi (monthAgoDate'den 30 gün önce)
    const startOfLastMonth = new Date(monthAgoDate);
    startOfLastMonth.setDate(monthAgoDate.getDate() - 30);

    // Tablonun kullandığı mantıkla tutarlı hale getirildi
    function countByDay(firma, dateStr, data) {
        const channelData = data?.[firma];
        if (!channelData || !channelData.dates) return 0;
        return channelData.dates[dateStr] || 0;
    }

     // Tablonun kullandığı mantıkla tutarlı hale getirildi
    function countByRange(firma, start, end, data) {
        const channelData = data?.[firma];
        if (!channelData || !channelData.dates) return 0;
        let total = 0;
        const startStr = format(start, 'yyyy-MM-dd');
        const endStr = format(end, 'yyyy-MM-dd');
        Object.entries(channelData.dates).forEach(([date, count]) => {
            // Tarih stringlerini karşılaştır
            if (date >= startStr && date <= endStr) {
                total += count;
            }
        });
        return total;
    }

     // Tablonun kullandığı mantıkla tutarlı hale getirildi
    function percentChange(current, prev) {
        if (prev === 0) return current === 0 ? 0 : Math.round((current / 1) * 100); // Payda 0 ise, pay > 0 ise %100 artış, pay = 0 ise %0 değişim
        return Math.round(((current - prev) / prev) * 100);
    }

    // 1. Satır: Başlıklar
    const headerRow = {
        Marka: 'Marka',
        Bugun: 'Bugün',
        Dun: 'Dün',
        OncekiGun: 'Önceki Gün',
        DoD: 'DoD',
        GecenHafta: 'Geçen Hafta',
        Wow: 'Wow',
        GecenAy: 'Geçen Ay',
        MoM: 'MoM'
    };

    // 2. Satır: Tarihler
    const dateRow = {
        Marka: 'Tarih',
        Bugun: format(todayDate, 'dd.MM.yyyy'),
        Dun: format(prevDayDate, 'dd.MM.yyyy'),
        OncekiGun: format(beforePrevDayDate, 'dd.MM.yyyy'),
        DoD: '',
        GecenHafta: format(weekAgoDate, 'dd.MM.yyyy'),
        Wow: '',
        GecenAy: format(monthAgoDate, 'dd.MM.yyyy'),
        MoM: ''
    };

    // Firma satırları
    const tableRows = tableFirms.map(firma => {
        // Ana statsData'yı kullanarak gün bazlı hesaplamalar
        const todayCount = countByDay(firma, todayStr, statsData);
        const prevDayCount = countByDay(firma, prevDayStr, statsData);
        const beforePrevDayCount = countByDay(firma, beforePrevDayStr, statsData);
        const weekCount = countByRange(firma, weekAgoDate, todayDate, statsData);
        // Geçen hafta için bir önceki 7 günün toplamı (MoM mantığı gibi)
        const lastWeekCount = countByRange(firma, startOfLastWeek, weekAgoDate, statsData);
        const monthCount = countByRange(firma, monthAgoDate, todayDate, statsData);

         // MoM sadece total ile hesaplanacak (prevMonthStats kullanılıyor)
        let lastMonthTotal = 0;
        if (prevMonthStats && prevMonthStats[firma] && prevMonthStats[firma].total) {
            lastMonthTotal = prevMonthStats[firma].total;
        }
        let thisMonthTotal = 0;
        if (statsData && statsData[firma] && statsData[firma].total) {
            thisMonthTotal = statsData[firma].total;
        }
        const MoM = percentChange(thisMonthTotal, lastMonthTotal);

        return {
            Marka: firma,
            Bugun: todayCount, // statsData'dan
            Dun: prevDayCount, // statsData'dan
            OncekiGun: beforePrevDayCount, // statsData'dan
            DoD: percentChange(todayCount, prevDayCount) + '%\n', // Yüzde işareti ve satır sonu
            GecenHafta: weekCount, // statsData'dan
            Wow: percentChange(weekCount, lastWeekCount) + '%\n', // Yüzde işareti ve satır sonu
            GecenAy: monthCount, // statsData'dan (son 30 gün)
            MoM: MoM + '%\n' // prevMonthStats kullanılarak hesaplandı
        };
    });

    // Toplam satırı
    const sum = (arr, key) => arr.reduce((a, b) => a + (typeof b[key] === 'number' ? b[key] : 0), 0);
    const totalBugun = sum(tableRows, 'Bugun');
    const totalDun = sum(tableRows, 'Dun');
    const totalOncekiGun = sum(tableRows, 'OncekiGun');
    const totalGecenHafta = sum(tableRows, 'GecenHafta');
    const totalGecenAy = sum(tableRows, 'GecenAy');

    // Toplamlar için yüzdeleri doğru hesapla, NaN ise 0% yaz
    const totalDoD = percentChange(totalBugun, totalDun) + '%\n';
    const totalWow = (() => {
        // Haftalık değişim için, toplam haftalık ve bir önceki haftalık toplamı bulmamız gerek
        const totalLastWeek = tableFirms.reduce((acc, firma) => {
            const lastWeekCount = countByRange(firma, startOfLastWeek, weekAgoDate, statsData);
            return acc + lastWeekCount;
        }, 0);
        return percentChange(totalGecenHafta, totalLastWeek) + '%\n';
    })();
     const totalMoM = (() => {
        // Aylık değişim için, toplam bu ay ve geçen ayı bulmamız gerek (prevMonthStats kullanılarak)
        const totalLastMonth = tableFirms.reduce((acc, firma) => {
            let lastMonthTotal = 0;
            if (prevMonthStats && prevMonthStats[firma] && prevMonthStats[firma].total) {
                lastMonthTotal = prevMonthStats[firma].total;
            }
            return acc + lastMonthTotal;
        }, 0);
        return percentChange(totalGecenAy, totalLastMonth) + '%\n';
    })();


    const totalRow = {
        Marka: 'E-Ticaret Toplam',
        Bugun: totalBugun,
        Dun: totalDun,
        OncekiGun: totalOncekiGun,
        DoD: totalDoD,
        GecenHafta: totalGecenHafta,
        Wow: totalWow,
        GecenAy: totalGecenAy,
        MoM: totalMoM
    };

    const formattedData = [
        dateRow,
        ...tableRows,
        totalRow
    ];

    api.post('excel/export', {
        type: 'excel',
        content: formattedData,
        header: {
            Marka: 'string',
            Bugun: 'number',
            Dun: 'number',
            OncekiGun: 'number',
            DoD: 'string',
            GecenHafta: 'number',
            Wow: 'string',
            GecenAy: 'number',
            MoM: 'string'
        },
        sheetTitle: `İşlem Adetleri ${dateRangeLabel}`
    }).then((response) => {
        if (response.data.status) {
            window.open(response.data.result, '_blank');
        }
    });
};

const exportKanalMarkaDagilimi = (statsData, dateRangeLabel) => {
    const markaList = firmaList;
    // Sıra: AVM, EPX, Esnaf
    const rows = markaList.map((marka) => {
        const channelData = statsData?.[marka];
        const avm = channelData?.isEasypointCount || 0;
        const epx = channelData?.isBoxCount || 0;
        const esnaf = channelData?.isEsnafCount || 0;
        const toplam = channelData?.total || 0;
        return { marka, kanalCounts: [avm, epx, esnaf], toplam };
    });
    const total = [
        rows.reduce((acc, row) => acc + row.kanalCounts[0], 0), // AVM
        rows.reduce((acc, row) => acc + row.kanalCounts[1], 0), // EPX
        rows.reduce((acc, row) => acc + row.kanalCounts[2], 0), // Esnaf
    ];
    const totalSum = rows.reduce((acc, row) => acc + row.toplam, 0);
    const formattedData = [
        { Marka: 'Marka', AVM: 'AVM', EPX: 'EPX', Esnaf: 'Esnaf', Toplam: 'Toplam' },
        ...rows.map(row => ({
            Marka: row.marka,
            AVM: row.kanalCounts[0],
            EPX: row.kanalCounts[1],
            Esnaf: row.kanalCounts[2],
            Toplam: row.toplam
        })),
        { Marka: 'Toplam', AVM: total[0], EPX: total[1], Esnaf: total[2], Toplam: totalSum }
    ];
    api.post('excel/export', {
        type: 'excel',
        content: formattedData,
        header: {
            Marka: 'string',
            AVM: 'number',
            EPX: 'number',
            Esnaf: 'number',
            Toplam: 'number'
        },
        sheetTitle: `Kanal ve Marka Dağılımı ${dateRangeLabel}`
    }).then((response) => {
        if (response.data.status) {
            window.open(response.data.result, '_blank');
        }
    });
};
const exportKanalMarkaDagilimiPDF = (statsData, dateRangeLabel) => {
    const markaList = firmaList;
    const rows = markaList.map((marka) => {
        const channelData = statsData?.[marka];
        const avm = channelData?.isEasypointCount || 0;
        const epx = channelData?.isBoxCount || 0;
        const esnaf = channelData?.isEsnafCount || 0;
        const toplam = channelData?.total || 0;
        return { marka, kanalCounts: [avm, epx, esnaf], toplam };
    });
    const total = [
        rows.reduce((acc, row) => acc + row.kanalCounts[0], 0),
        rows.reduce((acc, row) => acc + row.kanalCounts[1], 0),
        rows.reduce((acc, row) => acc + row.kanalCounts[2], 0),
    ];
    const totalSum = rows.reduce((acc, row) => acc + row.toplam, 0);

    const tableBody = [
        [
            { text: 'Marka', bold: true },
            { text: 'AVM', bold: true },
            { text: 'EPX', bold: true },
            { text: 'Esnaf', bold: true },
            { text: 'Toplam', bold: true }
        ],
        ...rows.map(row => [
            row.marka,
            row.kanalCounts[0],
            row.kanalCounts[1],
            row.kanalCounts[2],
            row.toplam
        ]),
        [
            { text: 'Toplam', bold: true },
            { text: total[0], bold: true },
            { text: total[1], bold: true },
            { text: total[2], bold: true },
            { text: totalSum, bold: true }
        ]
    ];

    const docDefinition = {
        content: [
            { text: `Kanal ve Marka Dağılımı ${dateRangeLabel}`, style: 'header' },
            {
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto', 'auto', 'auto', 'auto'],
                    body: tableBody
                }
            }
        ],
        styles: {
            header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] }
        }
    };
    pdfMake.createPdf(docDefinition).download(`kanal_marka_dagilimi_${dateRangeLabel}.pdf`);
};

const exportKanalMarkaDagilimiYuzdeselPDF = (statsData, dateRangeLabel) => {
    const markaList = firmaList;
    // Kanal sırası: AVM, EPX, Esnaf
    const rows = markaList.map((marka) => {
        const channelData = statsData?.[marka];
        const avm = channelData?.isEasypointCount || 0;
        const epx = channelData?.isBoxCount || 0;
        const esnaf = channelData?.isEsnafCount || 0;
        const toplam = channelData?.total || 0;
        return { marka, kanalCounts: [avm, epx, esnaf], toplam };
    });
    // Her kanal için toplamı bul
    const kanalTotals = [
        rows.reduce((acc, row) => acc + row.kanalCounts[0], 0), // AVM
        rows.reduce((acc, row) => acc + row.kanalCounts[1], 0), // EPX
        rows.reduce((acc, row) => acc + row.kanalCounts[2], 0), // Esnaf
    ];
    const totalSum = rows.reduce((acc, row) => acc + row.toplam, 0);
    // Yüzdeleri hesapla
    const percentRows = rows.map(row => ({
        marka: row.marka,
        kanalPercents: row.kanalCounts.map((val, idx) => kanalTotals[idx] ? ((val / kanalTotals[idx]) * 100).toFixed(1) : '0.0'),
        toplamPercent: totalSum ? ((row.toplam / totalSum) * 100).toFixed(1) : '0.0',
    }));
    // Tablo başlıkları ve satırları
    const tableBody = [
        [
            { text: 'Marka', bold: true },
            { text: 'AVM', bold: true },
            { text: 'EPX', bold: true },
            { text: 'Esnaf', bold: true },
            { text: 'Toplam', bold: true }
        ],
        ...percentRows.map(row => [
            row.marka,
            `${row.kanalPercents[0]}%`,
            `${row.kanalPercents[1]}%`,
            `${row.kanalPercents[2]}%`,
            `${row.toplamPercent}%`
        ]),
        [
            { text: 'Toplam', bold: true },
            { text: '100.0%', bold: true },
            { text: '100.0%', bold: true },
            { text: '100.0%', bold: true },
            { text: '100.0%', bold: true }
        ]
    ];
    const docDefinition = {
        content: [
            { text: `Kanal ve Marka Dağılımı (Yüzdesel) ${dateRangeLabel}`, style: 'header' },
            {
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto', 'auto', 'auto', 'auto'],
                    body: tableBody
                }
            }
        ],
        styles: {
            header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] }
        }
    };
    pdfMake.createPdf(docDefinition).download(`kanal_marka_dagilimi_yuzdesel_${dateRangeLabel}.pdf`);
};
const exportKanalMarkaDagilimiYuzdesel = (statsData, dateRangeLabel) => {
    const markaList = firmaList;
    const rows = markaList.map((marka) => {
        const channelData = statsData?.[marka];
        const avm = channelData?.isEasypointCount || 0;
        const epx = channelData?.isBoxCount || 0;
        const esnaf = channelData?.isEsnafCount || 0;
        const toplam = channelData?.total || 0;
        return { marka, kanalCounts: [avm, epx, esnaf], toplam };
    });
    const kanalTotals = [
        rows.reduce((acc, row) => acc + row.kanalCounts[0], 0),
        rows.reduce((acc, row) => acc + row.kanalCounts[1], 0),
        rows.reduce((acc, row) => acc + row.kanalCounts[2], 0),
    ];
    const totalSum = rows.reduce((acc, row) => acc + row.toplam, 0);
    const percentRows = rows.map(row => ({
        marka: row.marka,
        kanalPercents: row.kanalCounts.map((val, idx) => kanalTotals[idx] ? ((val / kanalTotals[idx]) * 100).toFixed(1) : '0.0'),
        toplamPercent: totalSum ? ((row.toplam / totalSum) * 100).toFixed(1) : '0.0',
    }));
    const formattedData = [
        { Marka: 'Marka', AVM: 'AVM', EPX: 'EPX', Esnaf: 'Esnaf', Toplam: 'Toplam' },
        ...percentRows.map(row => ({
            Marka: row.marka,
            AVM: `${row.kanalPercents[0]}%`,
            EPX: `${row.kanalPercents[1]}%`,
            Esnaf: `${row.kanalPercents[2]}%`,
            Toplam: `${row.toplamPercent}%`
        })),
        { Marka: 'Toplam', AVM: '100.0%', EPX: '100.0%', Esnaf: '100.0%', Toplam: '100.0%' }
    ];
    api.post('excel/export', {
        type: 'excel',
        content: formattedData,
        header: {
            Marka: 'string',
            AVM: 'string',
            EPX: 'string',
            Esnaf: 'string',
            Toplam: 'string'
        },
        sheetTitle: `Kanal ve Marka Dağılımı (Yüzdesel) ${dateRangeLabel}`
    }).then((response) => {
        if (response.data.status) {
            window.open(response.data.result, '_blank');
        }
    });
};

const exportDhlNoktalarPDF = (data, startDate, endDate) => {
    const baseDate = startDate || (data.length > 0 ? new Date(data[0].date) : new Date());
    const aylar = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    const ayAd = aylar[baseDate.getMonth()];
    const yil = baseDate.getFullYear();
    const points = [
        { name: 'Easy Point - Akmerkez', teslimatAdet: 1, teslimatTutar: '€ 0,5', ucretliAdet: 4, ucretliTutar: '€ 246' },
        { name: 'Easy Point - Symbol', teslimatAdet: 1, teslimatTutar: '€ 0,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
        { name: 'Easy Point - Kanyon', teslimatAdet: 8, teslimatTutar: '€ 0,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
        { name: 'Easy Point - Akasya', teslimatAdet: 3, teslimatTutar: '€ 2,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
        { name: 'Easy Point - Zorlu Center', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
        { name: 'Easy Point - Terracity', teslimatAdet: 0, teslimatTutar: '€ 2,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
        { name: 'Easy Point - Nev Çarşı', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
        { name: 'Easy Point - Gebze Center AVM', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 76' },
        { name: 'Easy Point - Ankara Cepa', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 0' },
        { name: 'Easy Point - Karşıyaka Hilltown', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 0' },
        { name: 'Easy Point - Kale Center', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 0' },
        { name: 'Easy Point - Maltepe Piazza', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 0' },
    ];
    const genelToplam = {
        teslimatAdet: points.reduce((a, b) => a + b.teslimatAdet, 0),
        teslimatTutar: '€ 12,0',
        ucretliAdet: points.reduce((a, b) => a + b.ucretliAdet, 0),
        ucretliTutar: '€ 642',
    };
    const tableBody = [
        [
            { text: 'Noktalar', bold: true },
            { text: 'Teslimat Adet', bold: true },
            { text: 'Teslimat Tutar', bold: true },
            { text: 'Ücretli Adet', bold: true },
            { text: 'Ücretli Tutar', bold: true }
        ],
        ...points.map(point => [
            point.name,
            point.teslimatAdet,
            point.teslimatTutar,
            point.ucretliAdet,
            point.ucretliTutar
        ]),
        [
            { text: 'Genel Toplam', bold: true },
            { text: genelToplam.teslimatAdet, bold: true },
            { text: genelToplam.teslimatTutar, bold: true },
            { text: genelToplam.ucretliAdet, bold: true },
            { text: genelToplam.ucretliTutar, bold: true }
        ]
    ];
    const docDefinition = {
        content: [
            { text: `${ayAd} ${yil} DHL`, style: 'header' },
            {
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto', 'auto', 'auto', 'auto'],
                    body: tableBody
                }
            }
        ],
        styles: {
            header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] }
        }
    };
    pdfMake.createPdf(docDefinition).download(`dhl_noktalar_${ayAd}_${yil}.pdf`);
};

const exportHaftalikGonderiPDF = (statsData, endDate, filterChannel, dateRangeLabel) => {
    const today = endDate || new Date();
    const weekDates = Array.from({ length: 7 }, (_, i) => {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        return format(date, 'yyyy-MM-dd');
    }).reverse();

    let channelKey = null;
    let channelLabel = '';
    if (filterChannel === 'EPX') {
        channelKey = 'isBoxCount';
        channelLabel = 'EPX';
    } else if (filterChannel === 'AVM') {
        channelKey = 'isEasypointCount';
        channelLabel = 'AVM';
    } else if (filterChannel === 'Esnaf') {
        channelKey = 'isEsnafCount';
        channelLabel = 'Esnaf';
    }

    const rows = firmaList.map(firma => {
        const channelData = statsData?.[firma];
        return {
            firma,
            counts: weekDates.map(date => channelData?.dates?.[date] || 0)
        };
    });

    const totalCounts = weekDates.map((date, idx) => rows.reduce((sum, row) => sum + row.counts[idx], 0));

    const tableBody = [
        [
            { text: channelLabel, bold: true },
            ...weekDates.map(date => ({ text: format(parseISO(date), 'dd.MM.yyyy'), bold: true }))
        ],
        ...rows.map(row => [
            row.firma,
            ...row.counts
        ]),
        [
            { text: 'Toplam', bold: true },
            ...totalCounts.map(t => ({ text: t, bold: true }))
        ]
    ];

    const docDefinition = {
        content: [
            { text: `Günlük Paket / Nokta (${channelLabel}) ${dateRangeLabel}`, style: 'header' },
            {
                table: {
                    headerRows: 1,
                    widths: ['*', ...weekDates.map(() => 'auto')],
                    body: tableBody
                }
            }
        ],
        styles: {
            header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] }
        }
    };
    pdfMake.createPdf(docDefinition).download(`haftalik_gonderi_${channelLabel}.pdf`);
};

// Excel versiyonu
const exportHaftalikGonderi = (statsData, endDate, filterChannel, dateRangeLabel) => {
    const today = endDate || new Date();
    const weekDates = Array.from({ length: 7 }, (_, i) => {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        return format(date, 'yyyy-MM-dd');
    }).reverse();

    let channelKey = null;
    let channelLabel = '';
    if (filterChannel === 'EPX') {
        channelKey = 'isBoxCount';
        channelLabel = 'EPX';
    } else if (filterChannel === 'AVM') {
        channelKey = 'isEasypointCount';
        channelLabel = 'AVM';
    } else if (filterChannel === 'Esnaf') {
        channelKey = 'isEsnafCount';
        channelLabel = 'Esnaf';
    } else if (filterChannel === 'Kurumsal') {
        channelKey = 'isCorporationalCount';
        channelLabel = 'Kurumsal';
    } else if (filterChannel === 'Bireysel') {
        channelKey = 'isPersonalCount';
        channelLabel = 'Bireysel';
    }

    const rows = firmaList.map(firma => {
        const channelData = statsData?.[firma];
        return {
            firma,
            counts: weekDates.map(date => channelData?.dates?.[date] || 0)
        };
    });
    const totalCounts = weekDates.map((date, idx) => rows.reduce((sum, row) => sum + row.counts[idx], 0));

    const formattedData = [
        {
            Firma: channelLabel,
            ...Object.fromEntries(weekDates.map(date => [format(parseISO(date), 'dd.MM.yyyy'), format(parseISO(date), 'dd.MM.yyyy')]))
        },
        ...rows.map(row => {
            const obj = { Firma: row.firma };
            weekDates.forEach((date, idx) => {
                obj[format(parseISO(date), 'dd.MM.yyyy')] = row.counts[idx];
            });
            return obj;
        }),
        (() => {
            const obj = { Firma: 'Toplam' };
            weekDates.forEach((date, idx) => {
                obj[format(parseISO(date), 'dd.MM.yyyy')] = totalCounts[idx];
            });
            return obj;
        })()
    ];
    const header = {
        Firma: 'string',
        ...Object.fromEntries(weekDates.map(date => [format(parseISO(date), 'dd.MM.yyyy'), 'number']))
    };    
    const firstDateFormatted = format(parseISO(weekDates[0]), 'dd.MM.yyyy');
    const lastDateFormatted = format(parseISO(weekDates[weekDates.length - 1]), 'dd.MM.yyyy');
    const newSheetTitle = `Günlük Paket-Nokta (${channelLabel}) ${firstDateFormatted} - ${lastDateFormatted}`;

    api.post('excel/export', {
        type: 'excel',
        content: formattedData,
        sheetTitle: newSheetTitle
    }).then((response) => {
        if (response.data.status) {
            window.open(response.data.result, '_blank');
        }
    });
};

const exportMarkaGenelIslemAdetleriPDF = (statsData) => {
    const markaList = [
        { name: 'HB', logo: '/assets/icons/stats-logos/hb.png', statsKey: 'hepsiburada' },
        { name: 'TY', logo: '/assets/icons/stats-logos/trendyol.png', statsKey: 'trendyol' },
        { name: 'Aras Kargo', logo: '/assets/icons/stats-logos/aras-kargo.png', statsKey: 'aras-kargo' },
        { name: 'Kargoist', logo: '/assets/icons/stats-logos/kargoist.svg', statsKey: 'kargoist' },
        { name: 'Hepsijet', logo: '/assets/icons/stats-logos/hepsijet.svg', statsKey: 'hepsijet' },
        //{ name: 'DHL', logo: '/assets/icons/stats-logos/dhl.png', statsKey: 'dhl' },
        //{ name: 'Shopify', logo: '/assets/icons/stats-logos/shopify.png', statsKey: 'shopify' },
    ];
    const markaWithCounts = markaList.map(m => ({
        ...m,
        value: statsData?.[m.statsKey]?.total || 0
    }));
    const tableBody = [
        [
            { text: 'Marka', bold: true },
            { text: 'İşlem Adedi', bold: true }
        ],
        ...markaWithCounts.map(m => [
            m.name,
            m.value
        ])
    ];
    const docDefinition = {
        content: [
            { text: 'Marka Bazlı Genel İşlem Adetleri', style: 'header' },
            {
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto'],
                    body: tableBody
                }
            }
        ],
        styles: {
            header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] }
        },
        defaultStyle: { fontSize: 10 }
    };
    pdfMake.createPdf(docDefinition).download(`marka_genel_islem_adetleri.pdf`);
};
const exportMarkaGenelIslemAdetleri = (statsData) => {
    const markaList = [
        { name: 'Hepsiburada', statsKey: 'hepsiburada' },
        { name: 'Trendyol', statsKey: 'trendyol' },
        { name: 'Aras Kargo', statsKey: 'aras-kargo' },
        //{ name: 'DHL', statsKey: 'dhl' },
        //{ name: 'Shopify', statsKey: 'shopify' },
        { name: 'KargoIst',statsKey: 'kargoist' },
        { name: 'Hepsijet', statsKey: 'hepsijet' },
    ];
    const markaWithCounts = markaList.map(m => ({
        name: m.name,
        value: statsData?.[m.statsKey]?.total || 0
    }));
    const formattedData = [
        { Marka: 'Marka', Adet: 'İşlem Adedi' },
        ...markaWithCounts.map(m => ({ Marka: m.name, Adet: m.value }))
    ];
    api.post('excel/export', {
        type: 'excel',
        content: formattedData,
        header: {
            Marka: 'string',
            Adet: 'number'
        },
        sheetTitle: 'Marka Bazlı Genel İşlem Adetleri'
    }).then((response) => {
        if (response.data.status) {
            window.open(response.data.result, '_blank');
        }
    });
};

// Veri dönüşüm yardımcı fonksiyonları
const transformStatsData = (statsData) => {
    if (!statsData || typeof statsData !== 'object') return [];

    const transformedData = [];

    Object.entries(statsData).forEach(([channel, data]) => {
        // Eğer data false ise veya geçerli bir obje değilse atla
        if (!data || data === false || typeof data !== 'object') return;

        // dates objesi yoksa veya geçerli değilse atla
        if (!data.dates || typeof data.dates !== 'object') return;

        // Günlük verileri dönüştür
        Object.entries(data.dates).forEach(([date, count]) => {
            transformedData.push({
                date,
                channel,
                firma: channel,
                total: count || 0,
                isBoxCount: data.isBoxCount || 0,
                isEasypointCount: data.isEasypointCount || 0,
                isEsnafCount: data.isEsnafCount || 0,
                deliveryType: 'Esnaf' // Varsayılan olarak Esnaf, daha sonra hesaplanacak
            });
        });
    });

    return transformedData;
};

const calculateDeliveryType = (item) => {
    const total = item.total;
    if (item.isBoxCount > 0) return 'EPX';
    if (item.isEasypointCount > 0) return 'AVM';
    if (item.isEsnafCount > 0) return 'Esnaf';
    return 'Esnaf'; // Varsayılan
};

// Helper function to map display marketplace names to data keys
const mapArasMarketplaceToDataKey = (marketplaceName) => {
    const mapping = {
        'Trendyol': 'trendyol',
        'Hepsiburada': 'hepsiburada',
        'Çiçek Sepeti': 'ciceksepeti',
        'FLO': 'flo',
        'Boyner': 'boyner',
        'Zara': 'zara',
        'LCW': 'lcw',
    };
    return mapping[marketplaceName] || marketplaceName.toLowerCase().replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u'); // Fallback for safety
};

export default function StatsPage() {
    // Tarih state'leri
    const today = new Date();
    const oneMonthAgo = subDays(today, 30);
    const [startDate, setStartDate] = useState(oneMonthAgo);
    const [endDate, setEndDate] = useState(today);
    const [selectedChannel, setSelectedChannel] = useState('Toplam');
    const [selectedDay, setSelectedDay] = useState('Tümü');
    const [statsData, setStatsData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isFiltering, setIsFiltering] = useState(false);
    const [selectedDeliveryType, setSelectedDeliveryType] = useState('Toplam');
    // --- STATE: Her chart için ayrı kanal filtresi ---
    const [selectedChannelMarkaDagilimi, setSelectedChannelMarkaDagilimi] = useState('Toplam');
    const [selectedChannelAktifNokta, setSelectedChannelAktifNokta] = useState('Toplam');
    const [prevMonthStats, setPrevMonthStats] = useState(null);
    const [momLoading, setMomLoading] = useState(false);

    // MoM için last month verisini çek
    const fetchLastMonthStats = async (startDate, endDate) => {
        setMomLoading(true);
        try {
            const prevStart = new Date(startDate);
            const prevEnd = new Date(endDate);
            const dayDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
            prevStart.setDate(prevStart.getDate() - dayDiff);
            prevEnd.setDate(prevEnd.getDate() - dayDiff);
            const response = await Services.GetStats({
                startDate: format(prevStart, 'yyyy-MM-dd'),
                endDate: format(prevEnd, 'yyyy-MM-dd'),
                channels: firmaList
            });
            if (response.data.status) {
                setPrevMonthStats(response.data.result);
            } else {
                setPrevMonthStats(null);
            }
        } catch (e) {
            setPrevMonthStats(null);
        } finally {
            setMomLoading(false);
        }
    };

    // Servis çağrısı
    const fetchStats = async () => {
        try {
            setLoading(true);
            setIsFiltering(true);
            const response = await Services.GetStats({
                startDate: format(startDate, 'yyyy-MM-dd'),
                endDate: format(endDate, 'yyyy-MM-dd'),
                channels: ["trendyol", "aras-kargo", "hepsijet", "hepsiburada", "kargoist", "shopify", "dhl"]
            });

            if (response.data.status) {
                setStatsData(response.data.result);
            } else {
                setError('Veri alınamadı');
            }
        } catch (err) {
            setError('Bir hata oluştu');
            console.error('Stats verisi alınırken hata:', err);
        } finally {
            setLoading(false);
            setIsFiltering(false);
        }
    };

    // İlk yükleme için
    useEffect(() => {
        fetchStats();
        fetchLastMonthStats(startDate, endDate);
    }, []);

    // Filtreleme butonu için handler
    const handleFilter = () => {
        fetchStats();
        fetchLastMonthStats(startDate, endDate);
    };

    // Filtreleme
    const filtered = useMemo(() => {
        if (!statsData) return [];

        const transformedData = transformStatsData(statsData);

        return transformedData.filter((item) => {
            let dateOk = true;
            if (startDate) dateOk = parseISO(item.date) >= startDate;
            if (endDate) dateOk = dateOk && parseISO(item.date) <= endDate;

            // Teslimat tipi filtrelemesi
            let deliveryTypeOk = true;
            if (selectedChannel !== 'Toplam') {
                if (selectedChannel === 'AVM') {
                    deliveryTypeOk = item.isEasypointCount > 0;
                } else if (selectedChannel === 'EPX') {
                    deliveryTypeOk = item.isBoxCount > 0;
                } else if (selectedChannel === 'Esnaf') {
                    deliveryTypeOk = item.isEsnafCount > 0;
                }
            }

            // Gün filtrelemesi
            let dayOk = true;
            if (selectedDay !== 'Tümü') {
                dayOk = getDayName(item.date) === selectedDay;
            }

            return dateOk && deliveryTypeOk && dayOk;
        });
    }, [statsData, startDate, endDate, selectedChannel, selectedDay]);

    // Donut: seçili kanalın altındaki gönderiler firmalara göre dağılım
    const firmaData = useMemo(() => {
        if (!statsData || typeof statsData !== 'object') return [];

        return firmaList.map((firma) => {
            const channelData = statsData[firma];
            if (!channelData || channelData === false || typeof channelData !== 'object') {
                return { name: firma, value: 0, color: firmaColors[firma] };
            }

            let value = 0;
            if (selectedChannel === 'Toplam') {
                value = channelData.total || 0;
            } else if (selectedChannel === 'AVM') {
                value = channelData.isEasypointCount || 0;
            } else if (selectedChannel === 'EPX') {
                value = channelData.isBoxCount || 0;
            } else if (selectedChannel === 'Esnaf') {
                value = channelData.isEsnafCount || 0;
            }

            return {
                name: firma,
                value: value,
                color: firmaColors[firma]
            };
        }).filter((d) => d.value > 0);
    }, [statsData, selectedChannel]);

    const firmaTotal = useMemo(() =>
        firmaData.reduce((acc, d) => acc + d.value, 0),
        [firmaData]
    );

    const firmaWithPercent = useMemo(() =>
        firmaData.map((d) => ({
            ...d,
            percent: firmaTotal ? Math.round((d.value / firmaTotal) * 100) : 0
        })),
        [firmaData, firmaTotal]
    );

    // --- GÜNLÜK PAKET / AKTİF NOKTA ÖZEL HESAPLAMA ---
    
    // Son 7 günün tarihlerini bul
    const last7Days = useMemo(() => {
        const baseDate = endDate ? new Date(endDate) : new Date();
        return Array.from({ length: 7 }, (_, i) => {
            const date = new Date(baseDate);
            date.setDate(baseDate.getDate() - i);
            return format(date, 'yyyy-MM-dd');
        }).reverse();
    }, [endDate]);

    // ToggleButton gün isimleri
    const dailyDayNames = useMemo(() => last7Days.map(date => getDayName(date)), [last7Days]);

    // Seçili günün tarihini bul
    const selectedDate = useMemo(() => selectedDay === 'Tümü' ? null : last7Days.find(date => getDayName(date) === selectedDay), [selectedDay, last7Days]);

    // Seçili gün için firma bazlı adetler
    const dailyFirms = useMemo(() => firmaList.map((firma) => {
        const channelData = statsData?.[firma];
        let value = 0;
        if (channelData && channelData.dates) {
            if (selectedDate) {
                value = channelData.dates[selectedDate] || 0;
            } else {
                // Tümü ise son 7 günün toplamı
                value = last7Days.reduce((sum, date) => sum + (channelData.dates[date] || 0), 0);
            }
        }
        return {
            name: firma,
            value,
            color: firmaColors[firma]
        };
    }).filter(d => d.value > 0), [statsData, selectedDate, last7Days]);

    // --- GÜNLÜK PAKET / AKTİF NOKTA CHART KULLANIMI ---
    // ToggleButtonGroup: dailyDayNames
    // DonutChart: data={dailyLegendWithPercent} total={dailyTotal} centerText={`${dailyTotal} Adet`}
    // Legend: dailyLegendWithPercent

    // Günlük Paket / Aktif Nokta: seçili kanal ve diğer filtrelere göre, günlere göre gönderi sayısı
    const dailyData = useMemo(() => {
        if (!statsData || typeof statsData !== 'object') return [];

        // Son 7 günün tarihlerini oluştur
        const last7DaysArr = last7Days;

        // Her gün için toplam sayıyı hesapla
        return last7DaysArr.map(date => {
            let totalCount = 0;
            Object.entries(statsData).forEach(([channel, channelData]) => {
                if (channelData && typeof channelData === 'object' && channelData.dates) {
                    // Seçili kanala göre değeri al
                    let value = 0;
                    if (selectedChannel === 'Toplam') {
                        value = channelData.dates[date] || 0;
                    } else if (selectedChannel === 'AVM') {
                        value = channelData.isEasypointCount || 0;
                    } else if (selectedChannel === 'EPX') {
                        value = channelData.isBoxCount || 0;
                    } else if (selectedChannel === 'Esnaf') {
                        value = channelData.isEsnafCount || 0;
                    }
                    totalCount += value;
                }
            });
            return {
                name: getDayName(date),
                value: totalCount,
                color: '#F2994A',
                date: date
            };
        }).filter(d => d.value > 0);
    }, [statsData, selectedChannel, last7Days]);

    // Günlük grafik legend verisi (selectedDay ve last7Days'e göre)
    const dailyLegendData = useMemo(() => {
        if (!statsData) return [];

        return firmaList.map((firma) => {
            const channelData = statsData?.[firma];
            let value = 0;

            if (channelData && channelData.dates) {
                if (selectedDay === 'Tümü') {
                    // selectedDay 'Tümü' ise, last7Days (endDate'e göre hesaplanan) toplamını al
                    value = last7Days.reduce((sum, date) => sum + (channelData.dates[date] || 0), 0);
                } else {
                    // Belirli bir gün seçili ise, o günün verisini al
                    const selectedDate = last7Days.find(date => getDayName(date) === selectedDay)?.date; // last7Days'ten tarihi bul
                    if (selectedDate) {
                         value = channelData.dates[selectedDate] || 0;
                    }
                }
            }
            return { name: firma, value, color: firmaColors[firma] };
        }).filter(d => d.value > 0); // Değeri 0 olanları filtrele
    }, [statsData, selectedDay, last7Days]); // Bağımlılıklar: statsData, selectedDay, last7Days

    // dailyLegendTotal ve dailyLegendWithPercent bu dailyLegendData'yı kullanacak
    const dailyLegendTotal = useMemo(
        () => dailyLegendData.reduce((acc, d) => acc + d.value, 0),
        [dailyLegendData]
    );

    const dailyLegendWithPercent = useMemo(
        () => dailyLegendData.map((d) => ({
            ...d,
            percent: dailyLegendTotal ? Math.round((d.value / dailyLegendTotal) * 100).toFixed(1) : '0.0'
        })),
        [dailyLegendData, dailyLegendTotal]
    );

    // Teslimata Göre Esnaf ve AVM: her firma için Esnaf ve AVM adetleri
    const deliveryTypeBarData = useMemo(() => {
        if (!statsData || typeof statsData !== 'object') return [];

        return firmaList.map((firma) => {
            const channelData = statsData[firma];
            if (!channelData || channelData === false || typeof channelData !== 'object') {
                return { firma, esnaf: 0, avm: 0 };
            }

            return {
                firma,
                esnaf: channelData.isEsnafCount || 0,
                avm: channelData.isEasypointCount || 0
            };
        });
    }, [statsData]);

    // 1. Günlük donut chart datası (sadece seçili günün firmaları veya tümü)
    // dailyDonutData, dailyDonutTotal, dailyDonutWithPercent zaten dailyLegendData/Total/WithPercent olarak hesaplanıyor
    // Bu değişken tanımlarını kaldırıyoruz ve aşağıdaki render kısmında dailyLegend* değişkenlerini kullanıyoruz.

    // Donut Chart SVG
    // Kanal ve Marka Dağılımı - Günlük Paket / Aktif Nokta
    function DonutChart({ data, total, centerText, centerSubtext, donutType }) {
        const radius = 60;
        const stroke = 16;
        const viewBox = 2 * (radius + stroke);
        let startAngle = 0;

        // Veri işleme mantığı donutType'a göre değişiyor
        const processedData = useMemo(() => {
            if (!data) return { chartData: [], sum: 0 };

            let chartData = data;
            if (donutType === 'AktifNokta') {
                // Günlük Paket / Aktif Nokta için veri işleme
                chartData = data.map(item => ({
                    ...item,
                    percent: total > 0 ? ((item.value / total) * 100).toFixed(1) : '0.0'
                }));
            } else if (donutType === 'MarkaDagilimi') {
                // Kanal ve Marka Dağılımı için veri işleme
                chartData = data.map(item => ({
                    ...item,
                    percent: total > 0 ? ((item.value / total) * 100).toFixed(1) : '0.0'
                }));
            }

            const sum = chartData.reduce((acc, d) => acc + d.value, 0);
            return { chartData, sum };
        }, [data, total, donutType]);

        // centerSubtext'i dizi olarak al
        const subtextLines = Array.isArray(centerSubtext) ? centerSubtext : String(centerSubtext).split(/\n|\\n/);

        return (
            <Box position="relative" width={viewBox} height={viewBox} mx="auto">
                <svg width={viewBox} height={viewBox}>
                    {processedData.chartData.map((d, i) => {
                        const angle = processedData.sum === 0 ? 0 : (d.value / processedData.sum) * 360;
                        const endAngle = startAngle + angle;
                        const largeArc = angle > 180 ? 1 : 0;
                        const x1 = radius + stroke + radius * Math.cos((Math.PI * (startAngle - 90)) / 180);
                        const y1 = radius + stroke + radius * Math.sin((Math.PI * (startAngle - 90)) / 180);
                        const x2 = radius + stroke + radius * Math.cos((Math.PI * (endAngle - 90)) / 180);
                        const y2 = radius + stroke + radius * Math.sin((Math.PI * (endAngle - 90)) / 180);
                        const path = `M${x1},${y1} A${radius},${radius} 0 ${largeArc} 1 ${x2},${y2}`;
                        const arc = (
                            <path
                                key={d.name}
                                d={path}
                                fill="none"
                                stroke={d.color}
                                strokeWidth={stroke}
                                strokeLinecap="butt"
                            />
                        );
                        startAngle += angle;
                        return arc;
                    })}
                </svg>
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    width={viewBox}
                    height={viewBox}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Typography variant="p" fontWeight={700} color="#222">
                        {centerText}
                    </Typography>
                    {subtextLines.map((line, idx) => (
                        <Typography key={idx} variant="subtitle2" color="text.secondary" sx={{ lineHeight: 1.1, fontSize: 13 }}>
                            {line}
                        </Typography>
                    ))}
                </Box>
            </Box>
        );
    }

    // Teslimata Göre Esnaf ve AVM Chart
    function BarChartEsnafAvm({ data }) {
        // Y ekseni için güzel aralıklar
        const rawMax = Math.max(...data.map((d) => Math.max(d.esnaf, d.avm)), 1);
        const yTicks = [500, 1000, 1500, 2000, 2500, 5000, 10000, 20000];
        const maxTick = yTicks.find((v) => v >= rawMax) || 20000;
        const ticks = yTicks.filter((v) => v <= maxTick);
        const height = 180;
        const barWidth = 22;
        const groupGap = 18;
        const maxVisible = 6;
        const chartData = data;
        const chartWidth = Math.max(chartData.length, maxVisible) * (barWidth * 2 + groupGap);
    
        return (
            <Box width="100%" display="flex" flexDirection="column" alignItems="center">
                <Box display="flex" width="100%" alignItems="flex-end">
                    {/* Y ekseni */}
                    <Box width={50} minWidth={50} maxWidth={50} height={height} position="relative" display="flex" flexDirection="column" justifyContent="space-between" alignItems="center" pr={3} zIndex={2} bgcolor="transparent">
                        {ticks.map((v, idx) => (
                            <Typography key={v} variant="caption" color="#888" sx={{ position: 'absolute', bottom: `${(100 * idx - (-4)) / (ticks.length - 1)}%`, right: '50%', fontSize: 15, fontWeight: 500 }}>{v}</Typography>
                        ))}
                    </Box>
                    {/* Barlar ve firma isimleri - ortalı */}
                    <Box flex={1} sx={{ overflowX: 'auto', minWidth: 0 }}>
                        <Box display="flex" alignItems="flex-end" minWidth={chartWidth}>
                            {chartData.map((d, i) => {
                                const esnafHeight = (d.esnaf / maxTick) * (height - 2);
                                const avmHeight = (d.avm / maxTick) * (height - 2);
                                return (
                                    <Box key={d.firma} display="flex" flexDirection="column" alignItems="center" mx={`${groupGap / 2}px`} width={barWidth * 2 + 4}>
                                        <svg width={barWidth * 2 + 4} height={height}>
                                            <rect
                                                x={0}
                                                y={height - esnafHeight}
                                                width={barWidth}
                                                height={esnafHeight}
                                                fill="#EB5757"
                                                rx={4}
                                            />
                                            <rect
                                                x={barWidth + 4}
                                                y={height - avmHeight}
                                                width={barWidth}
                                                height={avmHeight}
                                                fill="#F299A1"
                                                rx={4}
                                            />
                                        </svg>
                                        <Typography
                                            variant="caption"
                                            color="#888"
                                            width={barWidth * 2 + 20}
                                            textAlign="center"
                                            fontSize={11}
                                            fontWeight={400}
                                            lineHeight={1.1}
                                            mt={0.5}
                                            sx={{
                                                wordBreak: 'break-word',
                                                whiteSpace: 'normal',
                                                maxWidth: barWidth * 2 + 20,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {d.firma}
                                        </Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                </Box>
                {/* Alt çizgi */}
                <Box width="100%" borderBottom="1px solid #e0e0e0" mt={2} mb={2} />
                {/* Legend */}
                <Box display="flex" justifyContent="center" alignItems="center" gap={4} mt={1}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Box width={18} height={18} borderRadius="50%" bgcolor="#EB5757" />
                        <Typography variant="subtitle2" color="#515151" fontWeight={500}>Esnaf</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Box width={18} height={18} borderRadius="50%" bgcolor="#F299A1" />
                        <Typography variant="subtitle2" color="#515151" fontWeight={500}>Avm</Typography>
                    </Box>
                </Box>
            </Box>
        );
    }

    // Kanal ve Marka Dağılımı Tablosu (tarih filtresiyle dinamik)
    function KanalMarkaDagilimiTable({ dateRangeLabel }) {
        const markaList = firmaList;
        const kanalList = channelFilters.filter(c => c !== 'Toplam');
        // Her marka için statsData'dan değerleri al
        const rows = markaList.map((marka) => {
            const channelData = statsData?.[marka];
            const avm = channelData?.isEasypointCount || 0;
            const epx = channelData?.isBoxCount || 0;
            const esnaf = channelData?.isEsnafCount || 0;
            const toplam = channelData?.total || 0;
            // Sıra: AVM, EPX, Esnaf
            return { marka, kanalCounts: [avm, epx, esnaf], toplam };
        });
        const total = [
            rows.reduce((acc, row) => acc + row.kanalCounts[0], 0), // AVM
            rows.reduce((acc, row) => acc + row.kanalCounts[1], 0), // EPX
            rows.reduce((acc, row) => acc + row.kanalCounts[2], 0), // Esnaf
        ];
        const totalSum = rows.reduce((acc, row) => acc + row.toplam, 0);
        const formattedData = [
            { Marka: 'Marka', AVM: 'AVM', EPX: 'EPX', Esnaf: 'Esnaf', Toplam: 'Toplam' },
            ...rows.map(row => ({
                Marka: row.marka,
                AVM: row.kanalCounts[0],
                EPX: row.kanalCounts[1],
                Esnaf: row.kanalCounts[2],
                Toplam: row.toplam
            })),
            { Marka: 'Toplam', AVM: total[0], EPX: total[1], Esnaf: total[2], Toplam: totalSum }
        ];

        return (
            <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 0, mt: 4 }}>
                <Box bgcolor="#E95050" px={3} py={2} display="flex" alignItems="center" justifyContent="space-between" border=".5px solid #A52727">
                    <Typography variant="subtitle1" fontWeight={700} color="#fff">Kanal ve Marka Dağılımı <span style={{ fontWeight: 400, fontSize: 15, marginLeft: 8 }}>{dateRangeLabel}</span></Typography>
                    <Box display="flex" gap={1}>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportKanalMarkaDagilimiPDF(statsData, dateRangeLabel)}>Pdf olarak indir</Button>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportKanalMarkaDagilimi(statsData, dateRangeLabel)}>Excel'e aktar</Button>
                    </Box>
                </Box>
                <TableContainer
                    component={Paper}
                    sx={{
                        boxShadow: 0,
                        borderRadius: 0,
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                            height: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: '#f1f1f1',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#E95050',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: '#d13d3d',
                        }
                    }}
                >
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#E95050' }}>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, background: '#E95050', }}>Marka</TableCell>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>AVM</TableCell>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>EPX</TableCell>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>Esnaf</TableCell>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>Toplam</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.marka}>
                                    <TableCell sx={{ fontWeight: 700, backgroundColor: '#F4F4F4', color: '#515151', fontSize: 15 }}>{row.marka}</TableCell>
                                    <TableCell align="center">{row.kanalCounts[0]}</TableCell>
                                    <TableCell align="center">{row.kanalCounts[1]}</TableCell>
                                    <TableCell align="center">{row.kanalCounts[2]}</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 700 }}>{row.toplam}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 700, color: '#222', fontSize: 15 }}>Toplam</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{total[0]}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{total[1]}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{total[2]}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{totalSum}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        );
    }

    // Helper function to get specific Aras Kargo brands from datesDetails
    function getArasSpecificBrandsCount(dateStr, data) {
        const arasData = data?.["aras-kargo"];
        if (!arasData || !arasData.datesDetails || !arasData.datesDetails[dateStr]) return 0;

        const dayDetails = arasData.datesDetails[dateStr];
        let total = 0;
        // Include brands EXCEPT EPX, AVM, Esnaf, Kurumsal, Bireysel
        const excludedBrands = ['isBoxCount', 'isEasypointCount', 'isEsnafCount', 'isCorporationalCount', 'isPersonalCount'];

        Object.entries(dayDetails).forEach(([key, count]) => {
            if (!excludedBrands.includes(key)) {
                total += count || 0;
            }
        });
        return total;
    }

    // Helper function to get specific Aras Kargo brands count for a date range
    function getArasSpecificBrandsRangeCount(start, end, data) {
        const arasData = data?.["aras-kargo"];
        if (!arasData || !arasData.datesDetails) return 0;

        let total = 0;
        const startStr = format(start, 'yyyy-MM-dd');
        const endStr = format(end, 'yyyy-MM-dd');
        const excludedBrands = ['isBoxCount', 'isEasypointCount', 'isEsnafCount', 'isCorporationalCount', 'isPersonalCount'];

        Object.entries(arasData.datesDetails).forEach(([date, dayDetails]) => {
            if (date >= startStr && date <= endStr) {
                Object.entries(dayDetails).forEach(([key, count]) => {
                    if (!excludedBrands.includes(key)) {
                        total += count || 0;
                    }
                });
            }
        });
        return total;
    }

    // Aras Kargo İşlem Dağılımı PDF Export Fonksiyonu
    const exportArasIslemDagilimiPDF = (statsData, dateRangeLabel, startDate, endDate, prevMonthStats = null) => {
        const arasMarketplaces = [
            'Trendyol',
            'Hepsiburada',
            'Çiçek Sepeti',
            'FLO',
            'Boyner',
            'Zara',
            'LCW',
        ];

        const todayDate = endDate ? new Date(endDate) : new Date();
        const todayStr = format(todayDate, 'yyyy-MM-dd');
        const prevDayDate = new Date(todayDate); prevDayDate.setDate(todayDate.getDate() - 1);
        const prevDayStr = format(prevDayDate, 'yyyy-MM-dd');
        const beforePrevDayDate = new Date(todayDate); beforePrevDayDate.setDate(todayDate.getDate() - 2);
        const beforePrevDayStr = format(beforePrevDayDate, 'yyyy-MM-dd');
        const lastWeekEndDate = new Date(todayDate); lastWeekEndDate.setDate(todayDate.getDate() - 7);
        const lastWeekStartDate = new Date(lastWeekEndDate); lastWeekStartDate.setDate(lastWeekEndDate.getDate() - 6);
        const monthAgoDate = new Date(todayDate); monthAgoDate.setDate(todayDate.getDate() - 29);
        const startOfLastMonth = new Date(monthAgoDate); startOfLastMonth.setDate(monthAgoDate.getDate() - 30);

        // Helper functions
        const getMarketplaceCountByDay = (marketplaceName, dateStr, data) => {
            const arasData = data?.['aras-kargo'];
            if (!arasData || !arasData.datesDetails || !arasData.datesDetails[dateStr]) return 0;
            const dayDetails = arasData.datesDetails[dateStr];
            const dataKey = mapArasMarketplaceToDataKey(marketplaceName);
            return dayDetails?.[dataKey] || 0;
        };

        const getMarketplaceCountByRange = (marketplaceName, start, end, data) => {
            const arasData = data?.['aras-kargo'];
            if (!arasData || !arasData.datesDetails) return 0;

            const dataKey = mapArasMarketplaceToDataKey(marketplaceName);
            let total = 0;
            const startStr = format(start, 'yyyy-MM-dd');
            const endStr = format(end, 'yyyy-MM-dd');

            Object.entries(arasData.datesDetails).forEach(([date, dayDetails]) => {
                if (date >= startStr && date <= endStr) {
                    total += dayDetails?.[dataKey] || 0;
                }
            });
            return total;
        };

        function percentChange(current, prev) {
            if (prev === 0) return current === 0 ? 0 : 100;
            return Math.round(((current - prev) / prev) * 100);
        }

        const rows = arasMarketplaces.map(marketplace => {
            const todayCount = getMarketplaceCountByDay(marketplace, todayStr, statsData);
            const prevDayCount = getMarketplaceCountByDay(marketplace, prevDayStr, statsData);
            const beforePrevDayCount = getMarketplaceCountByDay(marketplace, beforePrevDayStr, statsData);
            const weekCount = getMarketplaceCountByRange(marketplace, lastWeekStartDate, lastWeekEndDate, statsData);
            let lastMonthCount = 0;
            if (prevMonthStats && prevMonthStats['aras-kargo'] && prevMonthStats['aras-kargo'].datesDetails) {
                const prevMonthArasData = prevMonthStats['aras-kargo'];
                const dataKey = mapArasMarketplaceToDataKey(marketplace);
                let prevMonthMarketplaceTotal = 0;
                if(prevMonthArasData.total && prevMonthArasData.total[mapArasMarketplaceToDataKey(marketplace)]){
                    prevMonthMarketplaceTotal = prevMonthArasData.total[mapArasMarketplaceToDataKey(marketplace)];
                } else if (prevMonthArasData.datesDetails) {
                    Object.entries(prevMonthArasData.datesDetails).forEach(([date, dayDetails]) => {
                        prevMonthMarketplaceTotal += dayDetails?.[dataKey] || 0;
                    });
                }
                lastMonthCount = prevMonthMarketplaceTotal;
            }

            let thisPeriodCount = 0;
            if(statsData && statsData['aras-kargo'] && statsData['aras-kargo'].datesDetails) {
                thisPeriodCount = getMarketplaceCountByRange(marketplace, startDate, endDate, statsData);
            }

            return [
                marketplace,
                todayCount === 0 ? '-' : todayCount,
                prevDayCount === 0 ? '-' : prevDayCount,
                beforePrevDayCount === 0 ? '-' : beforePrevDayCount,
                { text: `${percentChange(todayCount, prevDayCount)}%`, color: getChangeColor(percentChange(todayCount, prevDayCount)) },
                weekCount === 0 ? '-' : weekCount,
                { text: `${percentChange(weekCount, getMarketplaceCountByRange(marketplace, new Date(lastWeekStartDate.getTime() - 7 * 24 * 60 * 60 * 1000), new Date(lastWeekEndDate.getTime() - 7 * 24 * 60 * 60 * 1000), statsData))}%`, color: getChangeColor(percentChange(weekCount, getMarketplaceCountByRange(marketplace, new Date(lastWeekStartDate.getTime() - 7 * 24 * 60 * 60 * 1000), new Date(lastWeekEndDate.getTime() - 7 * 24 * 60 * 60 * 1000), statsData))) },
                thisPeriodCount === 0 ? '-' : thisPeriodCount,
                { text: `${percentChange(thisPeriodCount, lastMonthCount)}%`, color: getChangeColor(percentChange(thisPeriodCount, lastMonthCount)) }
            ];
        });

        const tableBody = [
            [ // Başlık satırı
                { text: 'Pazaryeri', bold: true },
                { text: 'Bugün', bold: true },
                { text: 'Dün', bold: true },
                { text: 'Önceki Gün', bold: true },
                { text: 'DoD', bold: true },
                { text: 'Geçen Hafta', bold: true },
                { text: 'Wow', bold: true },
                { text: 'Geçen Ay', bold: true },
                { text: 'MoM', bold: true }
            ],
            ...rows
        ];

        const docDefinition = {
            content: [
                { text: `Aras Kargo İşlem Dağılımı (Pazaryerleri) ${dateRangeLabel}`, style: 'header' },
                {
                    table: {
                        headerRows: 1,
                        widths: [
                            "*",
                            "auto", "auto", "auto", "auto", "auto", "auto", "auto", "auto"
                        ],
                        body: tableBody
                    }
                }
            ],
            styles: {
                header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] }
            }
        };
        pdfMake.createPdf(docDefinition).download(`aras_islem_dagilimi_pazaryerleri_${dateRangeLabel}.pdf`);
    };

    // Aras Kargo İşlem Dağılımı Excel Export Fonksiyonu
    const exportArasIslemDagilimiExcel = (statsData, dateRangeLabel, startDate, endDate, prevMonthStats = null) => {
        const arasMarketplaces = [
            'Trendyol',
            'Hepsiburada',
            'Çiçek Sepeti',
            'FLO',
            'Boyner',
            'Zara',
            'LCW',
        ];

        const todayDate = endDate ? new Date(endDate) : new Date();
        const todayStr = format(todayDate, 'yyyy-MM-dd');
        const prevDayDate = new Date(todayDate); prevDayDate.setDate(todayDate.getDate() - 1);
        const prevDayStr = format(prevDayDate, 'yyyy-MM-dd');
        const beforePrevDayDate = new Date(todayDate); beforePrevDayDate.setDate(todayDate.getDate() - 2);
        const beforePrevDayStr = format(beforePrevDayDate, 'yyyy-MM-dd');
        const lastWeekEndDate = new Date(todayDate); lastWeekEndDate.setDate(todayDate.getDate() - 7);
        const lastWeekStartDate = new Date(lastWeekEndDate); lastWeekStartDate.setDate(lastWeekEndDate.getDate() - 6);
        const monthAgoDate = new Date(todayDate); monthAgoDate.setDate(todayDate.getDate() - 29);
        const startOfLastMonth = new Date(monthAgoDate); startOfLastMonth.setDate(monthAgoDate.getDate() - 30);

        // Helper functions
        const getMarketplaceCountByDay = (marketplaceName, dateStr, data) => {
            const arasData = data?.['aras-kargo'];
            if (!arasData || !arasData.datesDetails || !arasData.datesDetails[dateStr]) return 0;
            const dayDetails = arasData.datesDetails[dateStr];
            const dataKey = mapArasMarketplaceToDataKey(marketplaceName);
            return dayDetails?.[dataKey] || 0;
        };

        const getMarketplaceCountByRange = (marketplaceName, start, end, data) => {
            const arasData = data?.['aras-kargo'];
            if (!arasData || !arasData.datesDetails) return 0;

            const dataKey = mapArasMarketplaceToDataKey(marketplaceName);
            let total = 0;
            const startStr = format(start, 'yyyy-MM-dd');
            const endStr = format(end, 'yyyy-MM-dd');

            Object.entries(arasData.datesDetails).forEach(([date, dayDetails]) => {
                if (date >= startStr && date <= endStr) {
                    total += dayDetails?.[dataKey] || 0;
                }
            });
            return total;
        };

        function percentChange(current, prev) {
            if (prev === 0) return current === 0 ? 0 : 100;
            return Math.round(((current - prev) / prev) * 100);
        }

        const rows = arasMarketplaces.map(marketplace => {
            const todayCount = getMarketplaceCountByDay(marketplace, todayStr, statsData);
            const prevDayCount = getMarketplaceCountByDay(marketplace, prevDayStr, statsData);
            const beforePrevDayCount = getMarketplaceCountByDay(marketplace, beforePrevDayStr, statsData);
            const weekCount = getMarketplaceCountByRange(marketplace, lastWeekStartDate, lastWeekEndDate, statsData);
             const lastWeekCountWow = getMarketplaceCountByRange(marketplace, new Date(lastWeekStartDate.getTime() - 7 * 24 * 60 * 60 * 1000), new Date(lastWeekEndDate.getTime() - 7 * 24 * 60 * 60 * 1000), statsData);
            let lastMonthCount = 0;
            if (prevMonthStats && prevMonthStats['aras-kargo'] && prevMonthStats['aras-kargo'].datesDetails) {
                const prevMonthArasData = prevMonthStats['aras-kargo'];
                const dataKey = mapArasMarketplaceToDataKey(marketplace);
                let prevMonthMarketplaceTotal = 0;
                if(prevMonthArasData.total && prevMonthArasData.total[mapArasMarketplaceToDataKey(marketplace)]){
                    prevMonthMarketplaceTotal = prevMonthArasData.total[mapArasMarketplaceToDataKey(marketplace)];
                } else if (prevMonthArasData.datesDetails) {
                    Object.entries(prevMonthArasData.datesDetails).forEach(([date, dayDetails]) => {
                        prevMonthMarketplaceTotal += dayDetails?.[dataKey] || 0;
                    });
                }
                lastMonthCount = prevMonthMarketplaceTotal;
            }

            let thisPeriodCount = 0;
            if(statsData && statsData['aras-kargo'] && statsData['aras-kargo'].datesDetails) {
                thisPeriodCount = getMarketplaceCountByRange(marketplace, startDate, endDate, statsData);
            }

            return {
                Pazaryeri: marketplace,
                Bugun: todayCount === 0 ? '-' : todayCount,
                Dun: prevDayCount === 0 ? '-' : prevDayCount,
                OncekiGun: beforePrevDayCount === 0 ? '-' : beforePrevDayCount,
                DoD: percentChange(todayCount, prevDayCount) + '%',
                GecenHafta: weekCount === 0 ? '-' : weekCount,
                Wow: percentChange(weekCount, lastWeekCountWow) + '%',
                GecenAy: thisPeriodCount === 0 ? '-' : thisPeriodCount,
                MoM: percentChange(thisPeriodCount, lastMonthCount) + '%'
            };
        });

        const formattedData = [
            ...rows
        ];

        api.post('excel/export', {
            type: 'excel',
            content: formattedData,
            header: {
                Pazaryeri: 'string',
                Bugun: 'string', // Changed to string because of '-'
                Dun: 'string', // Changed to string
                OncekiGun: 'string', // Changed to string
                DoD: 'string',
                GecenHafta: 'string', // Changed to string
                Wow: 'string',
                GecenAy: 'string', // Changed to string
                MoM: 'string'
            },
            sheetTitle: `Aras Kargo İşlem Dağılımı (Pazaryerleri) ${dateRangeLabel}`
        }).then((response) => {
            if (response.data.status) {
                window.open(response.data.result, '_blank');
            }
        });
    };

    // Aras Kargo İşlem Dağılımı Tablosu Komponenti
    function ArasIslemDagilimiTable({ statsData, dateRangeLabel, startDate, endDate, prevMonthStats, momLoading }) {
        // Aras Kargo'ya özel pazar yerleri listesi (Görüntüleme için)
        const arasMarketplaces = [
            'Trendyol',
            'Hepsiburada',
            'Çiçek Sepeti',
            'FLO',
            'Boyner',
            'Zara',
            'LCW',
        ];

        // Bugün: tarih filtresi varsa endDate, yoksa Date.now
        const todayDate = (typeof endDate !== 'undefined' && endDate) ? endDate : new Date();
        const todayStr = format(todayDate, 'yyyy-MM-dd');
        // Dün ve önceki gün
        const prevDayDate = new Date(todayDate); prevDayDate.setDate(todayDate.getDate() - 1);
        const prevDayStr = format(prevDayDate, 'yyyy-MM-MM-dd'); // Fix format string
        const beforePrevDayDate = new Date(todayDate); beforePrevDayDate.setDate(todayDate.getDate() - 2);
        const beforePrevDayStr = format(beforePrevDayDate, 'yyyy-MM-dd');
        // Geçen hafta (son 7 gün) - bitiş tarihi bugünden 7 gün önce
        const lastWeekEndDate = new Date(todayDate); lastWeekEndDate.setDate(todayDate.getDate() - 7);
        const lastWeekStartDate = new Date(lastWeekEndDate); lastWeekStartDate.setDate(lastWeekEndDate.getDate() - 6); // 7 gün öncesinin 6 gün öncesi
        // Geçen ay (son 30 gün) - bitiş tarihi bugünden 30 gün önce
        const lastMonthEndDate = new Date(todayDate); lastMonthEndDate.setDate(todayDate.getDate() - 30);
        const lastMonthStartDate = new Date(lastMonthEndDate); lastMonthStartDate.setDate(lastMonthEndDate.getDate() - 29); // 30 gün öncesinin 29 gün öncesi


        // Helper to get marketplace count for a specific date from Aras datesDetails
        const getMarketplaceCountByDay = (marketplaceName, dateStr, statsData) => {
            const arasData = statsData?.['aras-kargo'];
            if (!arasData || !arasData.datesDetails || !arasData.datesDetails[dateStr]) return 0;
            const dayDetails = arasData.datesDetails[dateStr];
            const dataKey = mapArasMarketplaceToDataKey(marketplaceName);
            return dayDetails?.[dataKey] || 0;
        };

        // Helper to get marketplace count for a date range from Aras datesDetails
         const getMarketplaceCountByRange = (marketplaceName, start, end, statsData) => {
            const arasData = statsData?.['aras-kargo'];
            if (!arasData || !arasData.datesDetails) return 0;

            const dataKey = mapArasMarketplaceToDataKey(marketplaceName);
            let total = 0;
            const startStr = format(start, 'yyyy-MM-dd');
            const endStr = format(end, 'yyyy-MM-dd');

            Object.entries(arasData.datesDetails).forEach(([date, dayDetails]) => {
                if (date >= startStr && date <= endStr) {
                     total += dayDetails?.[dataKey] || 0;
                }
            });
            return total;
        };

        function percentChange(current, prev) {
            if (prev === 0) return current === 0 ? 0 : 100; // Avoid division by zero
            return Math.round(((current - prev) / prev) * 100);
        }

        // Her pazar yeri için değerleri hesapla
        const rows = arasMarketplaces.map(marketplace => {
            const todayCount = getMarketplaceCountByDay(marketplace, todayStr, statsData);
            const prevDayCount = getMarketplaceCountByDay(marketplace, prevDayStr, statsData);
            const beforePrevDayCount = getMarketplaceCountByDay(marketplace, beforePrevDayStr, statsData);
            const weekCount = getMarketplaceCountByRange(marketplace, lastWeekStartDate, lastWeekEndDate, statsData);
             // Geçen ay için MoM hesaplaması prevMonthStats kullanılarak yapılacak
            let lastMonthCount = 0;
             if (prevMonthStats && prevMonthStats['aras-kargo'] && prevMonthStats['aras-kargo'].datesDetails) {
                 const prevMonthArasData = prevMonthStats['aras-kargo'];
                 const dataKey = mapArasMarketplaceToDataKey(marketplace);
                  // Toplamı al
                  let prevMonthMarketplaceTotal = 0;
                  // Eğer prevMonthStats aynı tarih aralığı içinse, range count alabiliriz.
                  // Ancak MoM genellikle bir önceki AYIN toplamıdır.
                  // Burada prevMonthStats, ana tarih aralığı ile AYNI SÜREdeki bir önceki dönemi içeriyor.
                  // Dolayısıyla, MoM için prevMonthStats içindeki ilgili pazar yerinin toplamını kullanmak daha doğru olur.
                  // Eğer prevMonthStats'ta ilgili pazaryeri toplamı yoksa, datesDetails içindeki tüm tarihlerin toplamını al
                  if(prevMonthArasData.total && prevMonthArasData.total[mapArasMarketplaceToDataKey(marketplace)]){
                      prevMonthMarketplaceTotal = prevMonthArasData.total[mapArasMarketplaceToDataKey(marketplace)];
                  } else if (prevMonthArasData.datesDetails) {
                      Object.entries(prevMonthArasData.datesDetails).forEach(([date, dayDetails]) => {
                          prevMonthMarketplaceTotal += dayDetails?.[dataKey] || 0;
                      });
                  }
                  lastMonthCount = prevMonthMarketplaceTotal;
             }

            // Bu ay/dönem için ilgili pazaryerinin toplamı
             let thisPeriodCount = 0;
             if(statsData && statsData['aras-kargo'] && statsData['aras-kargo'].datesDetails) {
                  const arasData = statsData['aras-kargo'];
                  const dataKey = mapArasMarketplaceToDataKey(marketplace);
                  // Mevcut tarih aralığındaki toplamı hesapla
                  thisPeriodCount = getMarketplaceCountByRange(marketplace, startDate, endDate, statsData);
             }


            return {
                marketplace,
                today: todayCount === 0 ? '-' : todayCount,
                prevDay: prevDayCount === 0 ? '-' : prevDayCount,
                beforePrevDay: beforePrevDayCount === 0 ? '-' : beforePrevDayCount,
                DoD: percentChange(todayCount, prevDayCount),
                week: weekCount === 0 ? '-' : weekCount,
                Wow: percentChange(weekCount, getMarketplaceCountByRange(marketplace, new Date(lastWeekStartDate.getTime() - 7 * 24 * 60 * 60 * 1000), new Date(lastWeekEndDate.getTime() - 7 * 24 * 60 * 60 * 1000), statsData)), // Wow için bir önceki haftayı hesapla
                month: thisPeriodCount === 0 ? '-' : thisPeriodCount, // Bu dönemdeki toplamı göster
                lastMonth: lastMonthCount === 0 ? '-' : lastMonthCount,
                MoM: percentChange(thisPeriodCount, lastMonthCount),
            };
        });

        // Toplam satırı hesapla
        const totalRow = {
            marketplace: 'Toplam',
            today: rows.reduce((sum, row) => sum + (row.today === '-' ? 0 : row.today), 0),
            prevDay: rows.reduce((sum, row) => sum + (row.prevDay === '-' ? 0 : row.prevDay), 0),
            beforePrevDay: rows.reduce((sum, row) => sum + (row.beforePrevDay === '-' ? 0 : row.beforePrevDay), 0),
             DoD: percentChange(
                rows.reduce((sum, row) => sum + (row.today === '-' ? 0 : row.today), 0),
                rows.reduce((sum, row) => sum + (row.prevDay === '-' ? 0 : row.prevDay), 0)
            ),
            week: rows.reduce((sum, row) => sum + (row.week === '-' ? 0 : row.week), 0),
            Wow: percentChange(
                rows.reduce((sum, row) => sum + (row.week === '-' ? 0 : row.week), 0),
                rows.reduce((sum, row) => sum + (row.lastWeek === '-' ? 0 : row.lastWeek), 0) // Toplam için bir önceki haftayı doğru hesapla
            ),
             month: rows.reduce((sum, row) => sum + (row.month === '-' ? 0 : row.month), 0),
             lastMonth: rows.reduce((sum, row) => sum + (row.lastMonth === '-' ? 0 : row.lastMonth), 0),
             MoM: percentChange(
                 rows.reduce((sum, row) => sum + (row.month === '-' ? 0 : row.month), 0),
                 rows.reduce((sum, row) => sum + (row.lastMonth === '-' ? 0 : row.lastMonth), 0)
             ),
        };

        return (
            <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 0, mt: 4 }}>
                <Box bgcolor="#E95050" px={3} py={2} display="flex" alignItems="center" justifyContent="space-between" border=".5px solid #A52727">
                    <Typography variant="subtitle1" fontWeight={700} color="#fff">Aras Kargo İşlem Dağılımı (Pazaryerleri) <span style={{ fontWeight: 400, fontSize: 15, marginLeft: 8 }}>{dateRangeLabel}</span></Typography>
                    <Box display="flex" gap={1}>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportArasIslemDagilimiPDF(statsData, dateRangeLabel, startDate, endDate, prevMonthStats)}>Pdf olarak indir</Button>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportArasIslemDagilimiExcel(statsData, dateRangeLabel, startDate, endDate, prevMonthStats)}>Excel'e aktar</Button>
                    </Box>
                </Box>
                <TableContainer
                    component={Paper}
                    sx={{
                        boxShadow: 0,
                        borderRadius: 0,
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                            height: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: '#f1f1f1',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#E95050',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: '#d13d3d',
                        }
                    }}
                >
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#E95050' }}>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0 }}>Pazaryeri</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Bugün</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Dün</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Önceki Gün</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>DoD</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Geçen Hafta</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Wow</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Geçen Ay</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>MoM</TableCell>
                            </TableRow>
                             {/* Tarih değerleri satırı - Ekran görüntüsünde yok, çıkarıldı */}
                        </TableHead>
                        <TableBody>
                            {rows.map(row => (
                                <TableRow key={row.marketplace}>
                                    <TableCell sx={{ fontWeight: 700, backgroundColor: '#F4F4F4', color: '#515151', fontSize: 15 }}>{row.marketplace}</TableCell>
                                    <TableCell align="center">{row.today}</TableCell>
                                    <TableCell align="center">{row.prevDay}</TableCell>
                                    <TableCell align="center">{row.beforePrevDay}</TableCell>
                                    <TableCell align="center" sx={{ color: getChangeColor(row.DoD), fontWeight: 700 }}>{row.DoD > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : row.DoD < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null}{row.DoD}%</TableCell>
                                    <TableCell align="center">{row.week}</TableCell>
                                    <TableCell align="center" sx={{ color: getChangeColor(row.Wow), fontWeight: 700 }}>{row.Wow > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : row.Wow < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null}{row.Wow}%</TableCell>
                                    <TableCell align="center">{row.month}</TableCell>
                                     <TableCell align="center" sx={{ color: getChangeColor(row.MoM), fontWeight: 700 }}>
                                        {momLoading && row.MoM === '-'
                                            ? <CircularProgress size={16} color="inherit" />
                                            : (row.MoM > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : row.MoM < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null)}
                                        {row.MoM !== '-' && `${row.MoM}%`}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        );
    }

    // Kanal ve Marka Dağılımı (Yüzdesel) Tablosu (tarih filtresiyle dinamik)
    function KanalMarkaDagilimiYuzdeselTable({ dateRangeLabel }) {
        const markaList = firmaList;
        // Kanal sırası: AVM, EPX, Esnaf
        // Her marka için statsData'dan değerleri al
        const rows = markaList.map((marka) => {
            const channelData = statsData?.[marka];
            const avm = channelData?.isEasypointCount || 0;
            const epx = channelData?.isBoxCount || 0;
            const esnaf = channelData?.isEsnafCount || 0;
            const toplam = channelData?.total || 0;
            return { marka, kanalCounts: [avm, epx, esnaf], toplam };
        });
        // Her kanal için toplamı bul
        const kanalTotals = [
            rows.reduce((acc, row) => acc + row.kanalCounts[0], 0), // AVM
            rows.reduce((acc, row) => acc + row.kanalCounts[1], 0), // EPX
            rows.reduce((acc, row) => acc + row.kanalCounts[2], 0), // Esnaf
        ];
        const totalSum = rows.reduce((acc, row) => acc + row.toplam, 0);
        // Yüzdeleri hesapla
        const percentRows = rows.map(row => ({
            marka: row.marka,
            kanalPercents: row.kanalCounts.map((val, idx) => kanalTotals[idx] ? ((val / kanalTotals[idx]) * 100).toFixed(1) : '0.0'),
            toplamPercent: totalSum ? ((row.toplam / totalSum) * 100).toFixed(1) : '0.0',
        }));
        // Tablo başlıkları ve satırları
        return (
            <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 0, mt: 4 }}>
                <Box bgcolor="#E95050" px={3} py={2} display="flex" alignItems="center" justifyContent="space-between" border=".5px solid #A52727">
                    <Typography variant="subtitle1" fontWeight={700} color="#fff">Kanal ve Marka Dağılımı (Yüzdesel) <span style={{ fontWeight: 400, fontSize: 15, marginLeft: 8 }}>{dateRangeLabel}</span></Typography>
                    <Box display="flex" gap={1}>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportKanalMarkaDagilimiYuzdeselPDF(statsData, dateRangeLabel)}>Pdf olarak indir</Button>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportKanalMarkaDagilimiYuzdesel(statsData, dateRangeLabel)}>Excel'e aktar</Button>
                    </Box>
                </Box>
                <TableContainer component={Paper} sx={{ boxShadow: 0, borderRadius: 0, overflowX: 'auto', '&::-webkit-scrollbar': { height: '8px' }, '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '4px' }, '&::-webkit-scrollbar-thumb': { background: '#E95050', borderRadius: '4px' }, '&::-webkit-scrollbar-thumb:hover': { background: '#d13d3d' } }}>
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#E95050' }}>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, background: '#E95050', }}>Marka</TableCell>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>AVM</TableCell>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>EPX</TableCell>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>Esnaf</TableCell>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>Toplam</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {percentRows.map((row) => (
                                <TableRow key={row.marka}>
                                    <TableCell sx={{ fontWeight: 700, backgroundColor: '#F4F4F4', color: '#515151', fontSize: 15 }}>{row.marka}</TableCell>
                                    <TableCell align="center">{row.kanalPercents[0]}%</TableCell>
                                    <TableCell align="center">{row.kanalPercents[1]}%</TableCell>
                                    <TableCell align="center">{row.kanalPercents[2]}%</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 700 }}>{row.toplamPercent}%</TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 700, color: '#222', fontSize: 15 }}>Toplam</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>100.0%</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>100.0%</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>100.0%</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>100.0%</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        );
    }

    // İşlem Adetleri tablosu için veriyi bugüne göre dinamik hesapla
    function IslemAdetleriTable({ filteredShipments, dateRangeLabel, prevMonthStats, momLoading }) {
        const tableFirms = firmaList;
        // Bugün: tarih filtresi varsa endDate, yoksa Date.now
        const todayDate = (typeof endDate !== 'undefined' && endDate) ? endDate : new Date();
        const todayStr = format(todayDate, 'yyyy-MM-dd');
        // Dün ve önceki gün
        const prevDayDate = new Date(todayDate); prevDayDate.setDate(todayDate.getDate() - 1);
        const prevDayStr = format(prevDayDate, 'yyyy-MM-dd');
        const beforePrevDayDate = new Date(todayDate); beforePrevDayDate.setDate(todayDate.getDate() - 2);
        const beforePrevDayStr = format(beforePrevDayDate, 'yyyy-MM-dd');
        // Geçen hafta (son 7 gün)
        const weekAgoDate = new Date(todayDate); weekAgoDate.setDate(todayDate.getDate() - 6);
        // Geçen ay (son 30 gün)
        const monthAgoDate = new Date(todayDate); monthAgoDate.setDate(todayDate.getDate() - 29);

        function countByDay(firma, dateStr) {
            const channelData = statsData?.[firma];
            if (!channelData || !channelData.dates) return 0;
            return channelData.dates[dateStr] || 0;
        }

        function countByRange(firma, start, end, customStatsData) {
            const channelData = (customStatsData || statsData)?.[firma];
            if (!channelData || !channelData.dates) return 0;
            let total = 0;
            const startStr = format(start, 'yyyy-MM-dd');
            const endStr = format(end, 'yyyy-MM-dd');
            Object.entries(channelData.dates).forEach(([date, count]) => {
                if (date >= startStr && date <= endStr) {
                    total += count;
                }
            });
            return total;
        }

        function percentChange(current, prev) {
            if (prev === 0) return current === 0 ? 0 : 100;
            return Math.round(((current - prev) / prev) * 100);
        }

        // MoM için iki veri setiyle karşılaştırma
        const tableRows = tableFirms.map(firma => {
            const todayCount = countByDay(firma, todayStr);
            const prevDayCount = countByDay(firma, prevDayStr);
            const beforePrevDayCount = countByDay(firma, beforePrevDayStr);
            const weekCount = countByRange(firma, weekAgoDate, todayDate);
            const lastWeekCount = countByRange(firma, new Date(weekAgoDate.getTime() - 7 * 24 * 60 * 60 * 1000), new Date(todayDate.getTime() - 7 * 24 * 60 * 60 * 1000));
            const monthCount = countByRange(firma, monthAgoDate, todayDate);
            // MoM sadece total ile hesaplanacak
            let lastMonthTotal = 0;
            if (prevMonthStats && prevMonthStats[firma] && prevMonthStats[firma].total) {
                lastMonthTotal = prevMonthStats[firma].total;
            }
            let thisMonthTotal = 0;
            if (statsData && statsData[firma] && statsData[firma].total) {
                thisMonthTotal = statsData[firma].total;
            }
            const MoM = lastMonthTotal === 0 ? (thisMonthTotal === 0 ? 0 : 100) : Math.round(((thisMonthTotal - lastMonthTotal) / lastMonthTotal) * 100);
            return {
                firma,
                today: todayCount,
                prevDay: prevDayCount,
                beforePrevDay: beforePrevDayCount,
                DoD: percentChange(todayCount, prevDayCount),
                week: weekCount,
                lastWeek: lastWeekCount,
                Wow: percentChange(weekCount, lastWeekCount),
                month: monthCount,
                lastMonth: lastMonthTotal,
                MoM: MoM,
            };
        });

        const totalRow = {
            firma: 'E-Ticaret Toplam',
            today: tableRows.reduce((a, b) => a + b.today, 0),
            prevDay: tableRows.reduce((a, b) => a + b.prevDay, 0),
            beforePrevDay: tableRows.reduce((a, b) => a + b.beforePrevDay, 0),
            DoD: percentChange(
                tableRows.reduce((a, b) => a + b.today, 0),
                tableRows.reduce((a, b) => a + b.prevDay, 0)
            ),
            week: tableRows.reduce((a, b) => a + b.week, 0),
            lastWeek: tableRows.reduce((a, b) => a + b.lastWeek, 0),
            Wow: percentChange(
                tableRows.reduce((a, b) => a + b.week, 0),
                tableRows.reduce((a, b) => a + b.lastWeek, 0)
            ),
            month: tableRows.reduce((a, b) => a + b.month, 0),
            lastMonth: tableRows.reduce((a, b) => a + b.lastMonth, 0),
            MoM: percentChange(
                tableRows.reduce((a, b) => a + b.month, 0),
                tableRows.reduce((a, b) => a + b.lastMonth, 0)
            ),
        };

        return (
            <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 0, mt: 4 }}>
                <Box bgcolor="#E95050" px={3} py={2} display="flex" alignItems="center" justifyContent="space-between" border=".5px solid #A52727">
                    <Typography variant="subtitle1" fontWeight={700} color="#fff">İşlem Adetleri <span style={{ fontWeight: 400, fontSize: 15, marginLeft: 8 }}>{dateRangeLabel}</span></Typography>
                    <Box display="flex" gap={1}>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportIslemAdetleriPDF(statsData, dateRangeLabel, startDate, endDate, prevMonthStats)}>Pdf olarak indir</Button>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportIslemAdetleriExcel(statsData, dateRangeLabel, startDate, endDate, prevMonthStats)}>Excel'e aktar</Button>
                    </Box>
                </Box>
                <TableContainer
                    component={Paper}
                    sx={{
                        boxShadow: 0,
                        borderRadius: 0,
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                            height: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: '#f1f1f1',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#E95050',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: '#d13d3d',
                        }
                    }}
                >
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#E95050' }}>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0 }}>Tarih</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Bugün</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Dün</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Önceki Gün</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>DoD</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Geçen Hafta</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Wow</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>Geçen Ay</TableCell>
                                <TableCell sx={{ color: '#fff', paddingBlock: 1, backgroundColor: '#E95050', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center' }}>MoM</TableCell>
                            </TableRow>
                            {/* Tarih değerleri satırı */}
                            <TableRow sx={{ bgcolor: '#fff' }}>
                                <TableCell sx={{ color: '#515151', backgroundColor: '#F4F4F4', fontWeight: 700, fontSize: 15, border: 0 }}>Marka</TableCell>
                                <TableCell sx={{ color: '#515151', fontWeight: 700, fontSize: 15, border: 0, textAlign: 'center' }}>{format(todayDate, 'dd.MM.yyyy')}</TableCell>
                                <TableCell sx={{ color: '#515151', fontWeight: 700, fontSize: 15, border: 0, textAlign: 'center' }}>{format(prevDayDate, 'dd.MM.yyyy')}</TableCell>
                                <TableCell sx={{ color: '#515151', fontWeight: 700, fontSize: 15, border: 0, textAlign: 'center' }}>{format(beforePrevDayDate, 'dd.MM.yyyy')}</TableCell>
                                <TableCell sx={{ color: '#515151', backgroundColor: '#E95050', fontWeight: 700, fontSize: 15, border: 0, textAlign: 'center' }}></TableCell>
                                <TableCell sx={{ color: '#515151', fontWeight: 700, fontSize: 15, border: 0, textAlign: 'center' }}>{format(weekAgoDate, 'dd.MM.yyyy')}</TableCell>
                                <TableCell sx={{ color: '#515151', backgroundColor: '#E95050', fontWeight: 700, fontSize: 15, border: 0, textAlign: 'center' }}></TableCell>
                                <TableCell sx={{ color: '#515151', fontWeight: 700, fontSize: 15, border: 0, textAlign: 'center' }}>{format(monthAgoDate, 'dd.MM.yyyy')}</TableCell>
                                <TableCell sx={{ color: '#515151', backgroundColor: '#E95050', fontWeight: 700, fontSize: 15, border: 0, textAlign: 'center' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableRows.map((row) => (
                                <TableRow key={row.firma}>
                                    <TableCell sx={{ fontWeight: 700, backgroundColor: '#F4F4F4', color: '#515151', fontSize: 15 }}>{row.firma}</TableCell>
                                    <TableCell align="center">{row.today}</TableCell>
                                    <TableCell align="center">{row.prevDay}</TableCell>
                                    <TableCell align="center">{row.beforePrevDay}</TableCell>
                                    <TableCell align="center" sx={{ color: row.DoD > 0 ? '#43A047' : row.DoD < 0 ? '#E95050' : '#888', fontWeight: 700 }}>{row.DoD > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : row.DoD < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null}{row.DoD}%</TableCell>
                                    <TableCell align="center">{row.week}</TableCell>
                                    <TableCell align="center" sx={{ color: row.Wow > 0 ? '#43A047' : row.Wow < 0 ? '#E95050' : '#888', fontWeight: 700 }}>{row.Wow > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : row.Wow < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null}{row.Wow}%</TableCell>
                                    <TableCell align="center">{row.month}</TableCell>
                                    <TableCell align="center" sx={{ color: row.MoM > 0 ? '#43A047' : row.MoM < 0 ? '#E95050' : '#888', fontWeight: 700 }}>
                                        {momLoading
                                            ? <CircularProgress size={16} color="inherit" />
                                            : (row.MoM > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : row.MoM < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null)}
                                        {!momLoading && `${row.MoM}%`}
                                    </TableCell>
                                </TableRow>
                            ))}
                            {/* Toplam satırı */}
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 700, color: '#222', fontSize: 15 }}>{totalRow.firma}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{totalRow.today}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{totalRow.prevDay}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{totalRow.beforePrevDay}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700, color: totalRow.DoD > 0 ? '#43A047' : totalRow.DoD < 0 ? '#E95050' : '#888' }}>{totalRow.DoD > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : totalRow.DoD < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null}{totalRow.DoD}%</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{totalRow.week}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700, color: totalRow.Wow > 0 ? '#43A047' : totalRow.Wow < 0 ? '#E95050' : '#888' }}>{totalRow.Wow > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : totalRow.Wow < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null}{totalRow.Wow}%</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>{totalRow.month}</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700, color: totalRow.MoM > 0 ? '#43A047' : totalRow.MoM < 0 ? '#E95050' : '#888' }}>
                                    {momLoading
                                        ? <CircularProgress size={16} color="inherit" />
                                        : (totalRow.MoM > 0 ? <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : totalRow.MoM < 0 ? <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> : null)}
                                    {!momLoading && `${totalRow.MoM}%`}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        );
    }

    // DHL Noktalar Tablosu (ay ismi dinamik)
    function DhlNoktalarTable({ filteredShipments, startDate, endDate }) {
        // Ay ve yıl başlık için
        const baseDate = startDate || (filteredShipments.length > 0 ? new Date(filteredShipments[0].date) : new Date());
        const ayAd = getMonthNameTR(baseDate);
        const yil = baseDate.getFullYear();
        // Mock veri (örnek)
        const points = [
            { name: 'Easy Point - Akmerkez', teslimatAdet: 1, teslimatTutar: '€ 0,5', ucretliAdet: 4, ucretliTutar: '€ 246' },
            { name: 'Easy Point - Symbol', teslimatAdet: 1, teslimatTutar: '€ 0,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
            { name: 'Easy Point - Kanyon', teslimatAdet: 8, teslimatTutar: '€ 0,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
            { name: 'Easy Point - Akasya', teslimatAdet: 3, teslimatTutar: '€ 2,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
            { name: 'Easy Point - Zorlu Center', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
            { name: 'Easy Point - Terracity', teslimatAdet: 0, teslimatTutar: '€ 2,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
            { name: 'Easy Point - Nev Çarşı', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 1, ucretliTutar: '€ 76' },
            { name: 'Easy Point - Gebze Center AVM', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 76' },
            { name: 'Easy Point - Ankara Cepa', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 0' },
            { name: 'Easy Point - Karşıyaka Hilltown', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 0' },
            { name: 'Easy Point - Kale Center', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 0' },
            { name: 'Easy Point - Maltepe Piazza', teslimatAdet: 1, teslimatTutar: '€ 2,5', ucretliAdet: 0, ucretliTutar: '€ 0' },
        ];
        const genelToplam = {
            teslimatAdet: points.reduce((a, b) => a + b.teslimatAdet, 0),
            teslimatTutar: '€ 12,0',
            ucretliAdet: points.reduce((a, b) => a + b.ucretliAdet, 0),
            ucretliTutar: '€ 642',
        };

        return (
            <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 0, mt: 4 }}>
                <Box bgcolor="#E95050" px={3} py={2} display="flex" alignItems="center" justifyContent="space-between" border=".5px solid #A52727">
                    <Typography variant="subtitle1" fontWeight={700} color="#fff">{ayAd} {yil} DHL</Typography>
                    <Box display="flex" gap={1}>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportDhlNoktalarPDF(filteredShipments, startDate, endDate)}>Pdf olarak indir</Button>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportDhlNoktalar(filteredShipments, startDate, endDate)}>Excel'e aktar</Button>
                    </Box>
                </Box>
                <TableContainer
                    component={Paper}
                    sx={{
                        boxShadow: 0,
                        borderRadius: 0,
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                            height: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: '#f1f1f1',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#E95050',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: '#d13d3d',
                        }
                    }}
                >
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#E95050', width: '100%' }}>
                                <TableCell sx={{ width: '25%', backgroundColor: '#E95050', color: '#fff', fontWeight: 700, fontSize: 16, border: 0, }}>Noktalar</TableCell>
                                <TableCell sx={{ width: '37.5%', backgroundColor: '#E95050', color: '#fff', fontWeight: 700, fontSize: 16, border: 0, }}>Teslimat</TableCell>
                                <TableCell sx={{ width: '37.5%', backgroundColor: '#E95050', color: '#fff', fontWeight: 700, fontSize: 16, border: 0, }}>Ücretli Gönderi</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {points.map((row) => (
                                <TableRow key={row.name}>
                                    <TableCell sx={{ width: '25%', fontWeight: 500, color: '#515151', fontSize: 15, border: "1px solid #E4E4E4" }}>
                                        {row.name}
                                    </TableCell>
                                    <TableCell sx={{ width: '37.5%', border: "1px solid #E4E4E4", p: 0 }}>
                                        <Box display="flex" flexDirection="row" alignItems="center" height="100%">
                                            <Box sx={{ width: '10%', textAlign: "center", fontWeight: 600, fontSize: 15, borderRight: "1px solid #E4E4E4", py: 2 }}>
                                                {row.teslimatAdet}
                                            </Box>
                                            <Box sx={{ width: '90%', pl: '7%', fontSize: 15 }}>
                                                {row.teslimatTutar}
                                            </Box>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ width: '37.5%', border: "1px solid #E4E4E4", p: 0 }}>
                                        <Box display="flex" flexDirection="row" alignItems="center" height="100%">
                                            <Box sx={{ width: '10%', textAlign: "center", fontWeight: 600, fontSize: 15, borderRight: "1px solid #E4E4E4", py: 2 }}>
                                                {row.ucretliAdet}
                                            </Box>
                                            <Box sx={{ width: '90%', pl: '7%', fontSize: 15 }}>
                                                {row.ucretliTutar}
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 700, color: '#222', fontSize: 15, border: "1px solid #E4E4E4" }}>Genel Toplam</TableCell>
                                <TableCell sx={{ fontWeight: 700, border: "1px solid #E4E4E4", p: 0 }}>
                                    <Box display="flex" flexDirection="row" alignItems="center" height="100%">
                                        <Box sx={{ width: '10%', textAlign: "center", fontWeight: 700, fontSize: 15, borderRight: "1px solid #E4E4E4", py: 1 }}>
                                            {genelToplam.teslimatAdet}
                                        </Box>
                                        <Box sx={{ width: '90%', pl: '7%', fontWeight: 700, fontSize: 15 }}>
                                            {genelToplam.teslimatTutar}
                                        </Box>
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ fontWeight: 700, border: "1px solid #E4E4E4", p: 0 }}>
                                    <Box display="flex" flexDirection="row" alignItems="center" height="100%">
                                        <Box sx={{ width: '10%', textAlign: "center", fontWeight: 700, fontSize: 15, borderRight: "1px solid #E4E4E4", py: 1 }}>
                                            {genelToplam.ucretliAdet}
                                        </Box>
                                        <Box sx={{ width: '90%', pl: '7%', fontWeight: 700, fontSize: 15 }}>
                                            {genelToplam.ucretliTutar}
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        );
    }

    // Marka Bazlı Genel İşlem Adetleri Tablosu (tarih filtresiyle dinamik, başlık sabit)
    function MarkaGenelIslemAdetleriTable({ filteredShipments }) {
        // Markalar
        const markaList = [
            { name: 'HB', logo: '/assets/icons/stats-logos/hb.png', statsKey: 'hepsiburada' },
            { name: 'TY', logo: '/assets/icons/stats-logos/trendyol.png', statsKey: 'trendyol' },
            { name: 'Aras Kargo', logo: '/assets/icons/stats-logos/aras-kargo.png', statsKey: 'aras-kargo' },
            { name: 'Aras EP', logo: '/assets/icons/stats-logos/aras-kargo.png', statsKey: 'araskargoOperationTotal' },
            { name: 'KargoIst', logo: '/assets/icons/stats-logos/kargoist.svg', statsKey: 'kargoist' },
            { name: 'Hepsijet', logo: '/assets/icons/stats-logos/hepsijet.svg', statsKey: 'hepsijet' },
            { name: 'DHL', logo: '/assets/icons/stats-logos/dhl.png', statsKey: 'dhlOperationTotal' },
            { name: 'Tax Free', logo: '/assets/icons/stats-logos/tax-free.png', statsKey: 'taxFreeOperationTotal' },
            //{ name: 'Shopify', logo: '/assets/icons/stats-logos/shopify.png', statsKey: 'shopify' },
        ];
        // Her bir markanın toplam adedi (statsData'dan)
        const markaWithCounts = markaList.map(m => ({
            ...m,
            value: statsData?.[m.statsKey]?.total || 0
        }));
        return (
            <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 1, mt: 4 }}>
                <Box bgcolor="#E95050" px={3} py={2} display="flex" alignItems="center" justifyContent="space-between" border=".5px solid #A52727">
                    <Typography variant="subtitle1" fontWeight={700} color="#fff">Marka Bazlı Genel İşlem Adetleri {dateRangeLabel}</Typography>
                    <Box display="flex" gap={1}>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportMarkaGenelIslemAdetleriPDF(statsData)}>Pdf olarak indir</Button>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportMarkaGenelIslemAdetleri(statsData)}>Excel'e aktar</Button>
                    </Box>
                </Box>
                <Box sx={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                    <Box display="flex" alignItems="center" minWidth={markaWithCounts.length * 120}>
                        {markaWithCounts.map((m) => (
                            <Box key={m.name} display="flex" flexDirection="column" alignItems="center" flexShrink={0} minWidth={120} flex={1}>
                                <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center", width: "100%", mb: 1, p: 1, backgroundColor: "#E95050" }}>
                                    <img src={m.logo} alt={m.name} style={{ width: 48, height: 48, objectFit: 'contain', borderRadius: m.name === 'SHOPIFY' ? '50%' : 8, background: m.name === 'SHOPIFY' ? '#222' : '#fff' }} />
                                    <Typography variant="subtitle2" fontWeight={700} color="#FFF" fontSize={15}>{m.name}</Typography>
                                </Box>
                                <Typography variant="p" fontWeight={700} color="#E95050" fontSize={14} mt={1} py={3}>
                                    {m.name === 'Aras EP' ? statsData?.araskargoOperationTotal?.toLocaleString() || 0 : 
                                     m.name === 'DHL' ? statsData?.dhlOperationTotal?.toLocaleString() || 0 : 
                                     m.name === 'Tax Free' ? statsData?.taxFreeOperationTotal?.toLocaleString() || 
                                     0 : m.value.toLocaleString()}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Paper>
        );
    }

    // Haftalık Gönderi Tablosu (son 7 gün, firmalara göre)
    function HaftalikGonderiTablosu({ endDate, filterChannel }) {
        // Son 7 günün tarihlerini bul (en güncelden eskiye)
        const today = endDate || new Date();
        const weekDates = Array.from({ length: 7 }, (_, i) => {
            const date = new Date(today);
            date.setDate(today.getDate() - i);
            return format(date, 'yyyy-MM-dd');
        }).reverse();

        // Kanal tipi seçimi
        let channelKey = null;
        let channelLabel = '';
        if (filterChannel === 'EPX') {
            channelKey = 'isBoxCount';
            channelLabel = 'EPX';
        } else if (filterChannel === 'AVM') {
            channelKey = 'isEasypointCount';
            channelLabel = 'AVM';
        } else if (filterChannel === 'Esnaf') {
            channelKey = 'isEsnafCount';
            channelLabel = 'Esnaf';
        } else if (filterChannel === 'Kurumsal') {
            channelKey = 'isCorporationalCount';
            channelLabel = 'Kurumsal';
        } else if (filterChannel === 'Bireysel') {
            channelKey = 'isPersonalCount';
            channelLabel = 'Bireysel';
        }

        // Her marka ve gün için değerleri al
        const rows = firmaList.map(firma => {
            const channelData = statsData?.[firma];
            if (!channelData || !channelData.datesDetails) return { firma, counts: weekDates.map(() => 0) };

            // Her gün için kanal bazlı sayıları hesapla
            const counts = weekDates.map(date => {
                // Eğer bu tarih için veri yoksa boş bırak
                if (!channelData.datesDetails[date]) return '-';
                
                const dayDetails = channelData.datesDetails[date];
                // Kanal bazlı sayıları al
                return dayDetails[channelKey] || 0;
            });

            return { firma, counts };
        });

        // Her gün için toplam
        const totalCounts = weekDates.map((_, idx) => {
            const sum = rows.reduce((acc, row) => {
                const count = row.counts[idx];
                // Eğer değer '-' ise toplama dahil etme
                return acc + (count === '-' ? 0 : count);
            }, 0);
            // Eğer hiç veri yoksa '-' göster
            return sum === 0 ? '-' : sum;
        });

        return (
            <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 0, mt: 4 }}>                                
                <Box bgcolor="#E95050" px={3} py={2} display="flex" alignItems="center" justifyContent="space-between" border=".5px solid #A52727">
                    <Typography variant="subtitle1" fontWeight={700} color="#fff">Günlük Paket / Nokta {filterChannel}</Typography>
                    <Box display="flex" gap={1}>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportHaftalikGonderiPDF(statsData, endDate, filterChannel, dateRangeLabel)}>Pdf olarak indir</Button>
                        <Button endIcon={<img src={downloadIcon} alt="" style={{ width: 20, height: 20 }} />} variant="contained" sx={{ bgcolor: '#fff', color: '#60656E', fontWeight: 600, borderColor: '#D0D5DD', borderRadius: 1, boxShadow: 0, px: 2, py: 1, '&:hover': { bgcolor: '#f5f5f5' } }} onClick={() => exportHaftalikGonderi(statsData, endDate, filterChannel, dateRangeLabel)}>Excel'e aktar</Button>
                    </Box>
                </Box>
                <TableContainer component={Paper} sx={{ boxShadow: 0, borderRadius: 0, overflowX: 'auto', '&::-webkit-scrollbar': { height: '8px' }, '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '4px' }, '&::-webkit-scrollbar-thumb': { background: '#E95050', borderRadius: '4px' }, '&::-webkit-scrollbar-thumb:hover': { background: '#d13d3d' } }}>
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#E95050' }}>
                                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, background: '#E95050', }}>{channelLabel}</TableCell>
                                {weekDates.map(date => (
                                    <TableCell key={date} sx={{ color: '#fff', fontWeight: 700, fontSize: 16, border: 0, textAlign: 'center', background: '#E95050', }}>{format(parseISO(date), 'dd.MM.yyyy')}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map(row => (
                                <TableRow key={row.firma}>
                                    <TableCell sx={{ fontWeight: 700, backgroundColor: '#F4F4F4', color: '#515151', fontSize: 15 }}>{row.firma}</TableCell>
                                    {row.counts.map((count, idx) => (
                                        <TableCell key={idx} align="center">{count}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 700, color: '#222', fontSize: 15 }}>Toplam</TableCell>
                                {totalCounts.map((count, idx) => (
                                    <TableCell key={idx} align="center" sx={{ fontWeight: 700 }}>{count}</TableCell>
                                ))}
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        );
    }

    const filteredShipmentsForTables = mockShipments.filter((item) => {
        let dateOk = true;
        if (startDate) dateOk = parseISO(item.date) >= startDate;
        if (endDate) dateOk = dateOk && parseISO(item.date) <= endDate;
        return dateOk;
    });
    const dateRangeLabel = getDateRangeLabel(startDate, endDate);

    // Tarih değişince günlük gün filtresini sıfırla
    useEffect(() => {
        setSelectedDay('Tümü');
    }, [startDate, endDate]);

    // Günlük Paket / Aktif Nokta gün seçimi için varsayılanı ayarla
    useEffect(() => {
        if (last7Days && last7Days.length > 0) {
            setSelectedDay('Tümü'); // Tümü seçili olacak, böylece tüm günler gösterilecek
        }
    }, [last7Days]);

    // --- VERİ İŞLEME: İki chart için ayrı useMemo'lar ---

    // Kanal ve Marka Dağılımı için veri hesaplama
    const markaDagilimiData = useMemo(() => {
        if (!statsData) return { data: [], total: 0 };

        const filteredData = firmaList.map(firma => {
            const channelData = statsData[firma];
            let value = 0;

            if (channelData && typeof channelData === 'object') { // channelData geçerli mi kontrol et
                if (selectedChannelMarkaDagilimi === 'Toplam') {
                    value = channelData.total || 0;
                } else if (selectedChannelMarkaDagilimi === 'AVM') {
                    value = channelData.isEasypointCount || 0;
                } else if (selectedChannelMarkaDagilimi === 'EPX') {
                    value = channelData.isBoxCount || 0;
                } else if (selectedChannelMarkaDagilimi === 'Esnaf') {
                    value = channelData.isEsnafCount || 0;
                } else if (selectedChannelMarkaDagilimi === 'Bireysel') {
                    value = channelData.isPersonalCount || 0;
                } else if (selectedChannelMarkaDagilimi === 'Kurumsal') {
                    value = channelData.isCorporationalCount || 0;
                }
            }

            return {
                name: firma,
                value: value,
                color: firmaColors[firma] || '#000' // Renk bulunamazsa varsayılan siyah
            };
        }).filter(d => d.value > 0); // Değeri 0 olan firmaları filtrele

        const total = filteredData.reduce((sum, item) => sum + item.value, 0);

        const dataWithPercent = filteredData.map(item => ({
            ...item,
            percent: total > 0 ? ((item.value / total) * 100).toFixed(1) : '0.0'
        }));

        return { data: dataWithPercent, total: total };
    }, [statsData, selectedChannelMarkaDagilimi]); // Bağımlılıklar: statsData ve Kanal ve Marka Dağılımı filtresi

    // Günlük Paket / Aktif Nokta için veri hesaplama
    const aktifNoktaData = useMemo(() => {
        if (!statsData) return { data: [], total: 0 };
        

        const filteredData = firmaList.map((firma) => {
            const channelData = statsData?.[firma];
            let value = 0;

            if (channelData && channelData.dates) {                
                if (selectedDay === 'Tümü') {
                    // selectedDay 'Tümü' ise, last7Days (endDate'e göre hesaplanan) toplamını al
                    value = last7Days.reduce((sum, date) => sum + (channelData.dates[date] || 0), 0);
                } else {
                    // Belirli bir gün seçili ise, o günün verisini al
                    const selectedDate = last7Days.find(date => date === selectedDay); // last7Days'ten tarihi bul
                    if (selectedDate) {
                         value = channelData.dates[selectedDate] || 0;
                    }
                }
            }
            return { name: firma, value, color: firmaColors[firma] };
        }).filter(d => d.value > 0); // Değeri 0 olanları filtrele

        const total = filteredData.reduce((acc, d) => acc + d.value, 0);

        const dataWithPercent = filteredData.map((d) => ({
            ...d,
            percent: total > 0 ? ((d.value / total) * 100).toFixed(1) : '0.0'
        }));

        return { data: dataWithPercent, total: total };
    }, [statsData, selectedDay, last7Days]); // Bağımlılıklar: statsData, Gün filtresi ve last7Days

    return (
        <Box p={3} bgcolor="#fafbfc" minHeight="100vh" width="100%">
            {isFiltering && (
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor : 'rgba(255,255,255,0.8)', 
                    opacity : 1,                   
                    filter: isFiltering ? 'blur(100px)' : 'none',
                    transition: 'filter 0.3s ease-in-out',
                    pointerEvents: isFiltering ? 'none' : 'auto',
                    zIndex: 1000
                }}>
                    <CircularProgress sx={{ color: '#E95050' }} />
                </Box>
            )}
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                <Typography variant="p">İstatistikler</Typography>
                <Grid container alignItems="center" justifyContent='flex-end' ml="auto" spacing={2}>
                    <Grid item>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
                            <DatePicker
                                label="Başlangıç Tarihi"
                                value={startDate}
                                onChange={setStartDate}
                                renderInput={(params) => <TextField {...params} size="small" />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
                            <DatePicker
                                label="Bitiş Tarihi"
                                value={endDate}
                                onChange={setEndDate}
                                renderInput={(params) => <TextField {...params} size="small" />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            onClick={handleFilter}
                            disabled={loading}
                            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                        >
                            {loading ? 'Yükleniyor...' : 'Filtrele'}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Grid container spacing={2} mb={2}>
                <Grid item xs={12} md={4} p={0} boxShadow={.5}>
                    <Card sx={{ padding: 2, borderRadius: 3, boxShadow: 0, display: 'flex', flexDirection: 'column', justifyContent: 'stretch' }}>
                        <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
                            <Typography variant="subtitle1" fontWeight={500} mb={1}>
                                Kanal ve Marka Dağılımı
                            </Typography>
                            <ToggleButtonGroup
                                value={selectedChannelMarkaDagilimi}
                                exclusive
                                onChange={(_, val) => val && setSelectedChannelMarkaDagilimi(val)}
                                size="medium"
                                sx={{ mb: 2, background: '#f6f8fa', borderRadius: 3, p: 0.5, boxShadow: '0 2px 8px #f0f0f0' }}
                            >
                                {channelFilters.map((c) => (
                                    <ToggleButton
                                        key={c}
                                        value={c}
                                        sx={{
                                            border: 0,
                                            fontWeight: 700,
                                            color: '#6B7280',
                                            borderRadius: 2,
                                            px: 2.5,
                                            py: 1,
                                            mx: 0.5,
                                            fontSize: 12,
                                            background: 'transparent',
                                            minWidth: 0,
                                            '&.Mui-selected': {
                                                background: '#fff',
                                                color: '#222',
                                                boxShadow: '0 2px 8px #ececec',
                                            },
                                        }}
                                    >
                                        {c}
                                    </ToggleButton>
                                ))}
                            </ToggleButtonGroup>
                            {/* Kanal ve Marka Dağılımı Donut Chart'ı */}
                            <DonutChart
                                data={markaDagilimiData.data}
                                total={markaDagilimiData.total}
                                centerText={`${markaDagilimiData.total} Adet`}
                                centerSubtext="Toplam"
                                donutType="MarkaDagilimi"
                            />
                            {/* Kanal ve Marka Dağılımı Legend */}
                            <Box mt='auto' borderTop='1px solid #e0e0e0' pt={2}>
                                <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center">
                                    {markaDagilimiData.data.map((item) => (
                                        <Typography key={item.name} variant="caption" color="#515151" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', background: item.color, display: 'inline-block', mr: 0.5 }} />
                                            <b>{item.name}:</b> {item.value} (%{item.percent})
                                        </Typography>
                                    ))}
                                </Stack>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4} p={0} boxShadow={.5}>
                    <Card sx={{ padding: 2, borderRadius: 3, boxShadow: 0, height: 348, display: 'flex', flexDirection: 'column', justifyContent: 'stretch' }}>
                        <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                <Typography variant="subtitle1" fontWeight={500}>
                                    Günlük Paket / Aktif Nokta
                                </Typography>
                                {/* selectedChannelAktifNokta yerine setSelectedDay kullanıyoruz */}
                                <Button variant="outlined" size="small" sx={{ ml: 2, fontWeight: 600, borderRadius: 2, textTransform: 'none', fontSize: 13, px: 2, py: 0.5 }} onClick={() => setSelectedDay('Tümü')}>
                                    Hepsi
                                </Button>
                            </Box>
                            {/* Günlük Paket / Aktif Nokta Gün Butonları */}
                            <ToggleButtonGroup
                                value={selectedDay}
                                exclusive
                                onChange={(_, val) => val && setSelectedDay(val)}
                                size="medium"
                                sx={{ mb: 2, background: '#f6f8fa', borderRadius: 3, p: 0.5, boxShadow: '0 2px 8px #f0f0f0' }}
                            >
                                {/* dailyData yerine last7Days'ten gün isimlerini alıyoruz */}
                                {last7Days.map((date) => (
                                    <ToggleButton
                                        key={date}
                                        value={date}
                                        sx={{ border: 0, fontWeight: 700, fontSize: 12, color: '#6B7280', borderRadius: 3, px: 2.5, py: 1, mx: 0.5, background: 'transparent', minWidth: 0, '&.Mui-selected': { background: '#fff', color: '#222', boxShadow: '0 2px 8px #ececec' } }}
                                    >
                                        {getDayName(date)}
                                    </ToggleButton>
                                ))}
                            </ToggleButtonGroup>
                            {/* Günlük Paket / Aktif Nokta Donut Chart'ı */}
                            <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
                                <DonutChart
                                    data={aktifNoktaData.data}
                                    total={aktifNoktaData.total}
                                    centerText={`${aktifNoktaData.total} Adet`}
                                    centerSubtext={['Toplam', 'Aktif Nokta']}
                                    donutType="AktifNokta"
                                />
                            </Box>
                            {/* Günlük grafik legend */}
                            <Box mt='auto' borderTop='1px solid #e0e0e0' pt={2}>
                                <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center">
                                    {aktifNoktaData.data.map((item) => (
                                        <Typography key={item.name} variant="caption" color="#515151" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', background: item.color, display: 'inline-block', mr: 0.5 }} />
                                            <b>{item.name}:</b> {item.value} (%{item.percent})
                                        </Typography>
                                    ))}
                                </Stack>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4} p={0} boxShadow={.5}>
                    <Card sx={{ padding: 2, paddingLeft: 5, borderRadius: 3, boxShadow: 0, height: 348, display: 'flex', flexDirection: 'column', justifyContent: 'stretch' }}>
                        <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
                            <Typography variant="subtitle1" fontWeight={500} mb={2}>
                                Teslimata Göre Esnaf ve AVM
                            </Typography>
                            <BarChartEsnafAvm data={deliveryTypeBarData} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Box mt={6}>
                <IslemAdetleriTable 
                    filteredShipments={filteredShipmentsForTables} 
                    dateRangeLabel={dateRangeLabel} 
                    prevMonthStats={prevMonthStats}
                    momLoading={momLoading}
                />
                <KanalMarkaDagilimiTable dateRangeLabel={dateRangeLabel} />
                <KanalMarkaDagilimiYuzdeselTable dateRangeLabel={dateRangeLabel} />
                {/*<DhlNoktalarTable filteredShipments={filteredShipmentsForTables} startDate={startDate} endDate={endDate} /> */}
                <MarkaGenelIslemAdetleriTable filteredShipments={filteredShipmentsForTables} />
                <HaftalikGonderiTablosu
                    endDate={endDate}
                    filterChannel="EPX"
                />
                <HaftalikGonderiTablosu
                    endDate={endDate}
                    filterChannel="Esnaf"
                />
                <HaftalikGonderiTablosu
                    endDate={endDate}
                    filterChannel="AVM"
                />
                <HaftalikGonderiTablosu
                    endDate={endDate}
                    filterChannel="Kurumsal"
                />
                <HaftalikGonderiTablosu
                    endDate={endDate}
                    filterChannel="Bireysel"
                />
                <ArasIslemDagilimiTable
                    statsData={statsData}
                    dateRangeLabel={dateRangeLabel}
                    startDate={startDate}
                    endDate={endDate}
                    prevMonthStats={prevMonthStats}
                    momLoading={momLoading}
                />
            </Box>
        </Box>
    );
}